"use strict";
/* global BaseAPI, LayoutAPI, ControlAPI, ModelAPI, moment, Grid, CKEDITOR, attachmentsModels, rowOrderDetailConformity, SETTINGS */

/**
 * SOLVNET nous fournit toutes les APIs de base pour l'application
 */
var SOLVNET = {
	isIE: (navigator.userAgent.indexOf('MSIE') >= 0 || navigator.userAgent.indexOf('Trident/') >= 0),
	isIphone: (navigator.userAgent.indexOf('iPhone') >= 0),
	navigatorDecimalSeparator: (0.1).toLocaleString().replace(/\d/g, ''),

	// initialisé dans index.jsp
	online: undefined,
	// initialisés via SOLVNET.init
	userId: undefined,
	profileId: undefined,
	cartoAvailable: false,
	bookAvailable: false,
	feedbackAvailable: false,
	isSuperAdmin: false,

	palettes: {
		Default: '#B3DC10,#F52A26,#6BC8EA,#B3B3B3,#FDD505,#07AA75,#F89833,#4297CD,#6EB961,#B57EA9,#EEEEEE,#669999,#D9E681,#FA6254,#37BCDA,#808080,#FCDE6C,#85D1AE,#F7B268,#73B4E4,#87BB6F,#CE7AAA,#DCDCDC,#A1D8EF,#BAEB57,#FA7E3A,#6699FF,#C0C0C0,#33CC66,#FCEC83',
		Green: '#B3DC10,#07AA75,#6EB961,#D7D7D7,#8FC579,#C0D084,#87B8C4,#CCCCCC,#D9E681,#D7F29F,#52B476,#C0C0C0,#EFED6F,#A3CC7B,#A9BEA1,#B3B3B3,#669999,#BAEB57,#87BB6F,#DCDCDC,#8DBF37,#6EB961,#D7DB35,#999999,#33CC66,#91AD75,#85D1AE,#EEEEEE,#81B763,#D4DE67',
		Pastel: '#D2D4D1,#C2E3E4,#F9EBB4,#DBC4E7,#F6C3B4,#DDEA90,#B8CBE1,#FEBC93,#C3DCAA,#E9B5D8,#F8EB55,#E18F73,#8ECBB3,#E0CF6D,#37BCDA,#FCC997,#8ECCAA,#F1D2DF,#EDEDED,#85A7C4,#D7D394,#B0D3F0,#B1C36E,#FEB36F,#E097B6,#FCF2A9,#CEEBEF,#D5AA9C,#ECE0A5,#B3D48F',
		NewBI: '#CBEB5C,#FF8093,#6BC8EA,#FEEA7A,#07C0A0,#FFBA8C,#FFEDAE,#C3C3C3,#CAECF4,#E1C7B9,#F47A6F,#FC4B51,#518BC1,#93B181,#D3777E',
		Custom: ''
	},

	/**
	 * La méthode suivante retourne un tableau de couleurs CSS extraite de la palette.
	 *
	 * @param {String} palette - la palette qui peut être un noom "Green", "Pastel", "Custom", ... ou une liste sépararée par ","
	 * @param {Object} SETTINGS - la variable globalle "SETTINGS" pour récupérer la palette personnalisée si (palette === "Custom")
	 * @return un tableau de chaine de caractères où chaque entrée en une couleur
	 */
	paletteToColors: function(palette, SETTINGS) {
		if (!palette)
			return null;
		if (palette === 'Custom')
			return SETTINGS.customPalette.split(',');
		if (SOLVNET.palettes[palette])
			return SOLVNET.palettes[palette].split(',');
		return palette.split(',');
	},

	/**
	 * La méthode à appeler depuis la page principale pour initialiser correctement SOLVNET
	 *
	 * @param urlPrefix le préfix (=contexte) pour les URLs
	 */
	init: function(urlPrefix, userId, profileId, cartoAvailable, bookAvailable, feedbackAvailable, isSuperAdmin) {
		SOLVNET.urlPrefix = urlPrefix;
		SOLVNET.userId = userId;
		SOLVNET.profileId = profileId;
		SOLVNET.cartoAvailable = cartoAvailable;
		SOLVNET.bookAvailable = bookAvailable;
		SOLVNET.feedbackAvailable = feedbackAvailable;
		SOLVNET.isSuperAdmin = isSuperAdmin;

		if(SOLVNET.isIphone) {
			var patternAllowedCharForNumber = /[\d-]/;
			// On filtre les touches pour la saisie de numérique sur iphone.
			$(document).on("keypress","input[type='number']", function(event) {
				var c =  String.fromCharCode(event.charCode);
				if(event.charCode === 0 || c === SOLVNET.navigatorDecimalSeparator || patternAllowedCharForNumber.test(c)) {
					return;
				}
				event.preventDefault();
			});
		}

		$.ajaxSetup({ cache: false });

		// Configuration des "modal" de Bootstrap pour qu'elle ne se ferment pas quand on clique ailleurs par défaut
		if ($.fn.modal) {
			$.fn.modal.Constructor.DEFAULTS.backdrop = 'static';
		}

		// Configuration du composant Datetimepicker
		if ($.fn.datetimepicker) {
			$.extend($.fn.datetimepicker.defaults.tooltips, SOLVNET.lang.DatetimePicker.tooltips);
		}

		// Configuration du composant Highcharts
		if (window.Highcharts) {
			window.Highcharts.setOptions({
				lang: SOLVNET.getLang('HighchartsLang')
			});
		}

		// Configuration par défaut de la grille
		if ($.fn.grid) {
			Grid.prototype.defaultOptions.bordered = false;
			Grid.prototype.defaultOptions.removeGroupHTML = '<i class="material-icons text-primary">cancel</i>';
			Grid.prototype.defaultOptions.moveToFirstPageHTML = '<i class="material-icons">first_page</i>';
			Grid.prototype.defaultOptions.moveToPreviousPageHTML = '<i class="material-icons">chevron_left</i>';
			Grid.prototype.defaultOptions.moveToNextPageHTML = '<i class="material-icons">chevron_right</i>';
			Grid.prototype.defaultOptions.moveToLastPageHTML = '<i class="material-icons">last_page</i>';
			Grid.prototype.defaultOptions.notReadyHTML = '<i class="material-icons bbm-grid-loading">refresh</i>';
			Grid.prototype.defaultOptions.booleanTrueContent = '<i class="material-icons text-primary">check_box</i>';
			Grid.prototype.defaultOptions.booleanFalseContent = '<i class="material-icons" style="color: rgba(0, 0, 0, .54);">check_box_outline_blank</i>';
			Grid.prototype.defaultOptions.booleanTrueText = SOLVNET.getLang('InputBooleanYes');
			Grid.prototype.defaultOptions.booleanFalseText = SOLVNET.getLang('InputBooleanNo');
			Grid.prototype.defaultOptions.selectionTrueContent = Grid.prototype.defaultOptions.booleanTrueContent;
			Grid.prototype.defaultOptions.selectionFalseContent = Grid.prototype.defaultOptions.booleanFalseContent;
			Grid.prototype.defaultOptions.numberNaNMessage = function(caption) { return SOLVNET.getLang('InputNaNMessage', caption); };
			Grid.prototype.defaultOptions.placeholderColor = '#bbbbbb';
			Grid.prototype.defaultOptions.textColor = '#666666';
			Grid.prototype.defaultOptions.onerror = function(grid, errors, row) { SOLVNET.showErrors(errors); };
		}
	},

	/**
	 * Préfixe pour la construction d'URL, par défaut '/' mais en fait préciser via "SOLVNET.init".
	 */
	urlPrefix: '/',

	/**
	 * Cette fonction retourne une URL complète à partir d'une URL applicative en la préfixant de "SOLVNET.urlPrefix"
	 *
	 * @param baseURL une URL application, par exemple 'app/note'
	 * @param optionnalParams un objet contenant les paramètres à ajouter à l'URL, par exemple {name: 'toto', year: 2015}
	 * @returns {String} une URL complète, par exemple '/bbsolvnet2/app/note?name=toto&year=2015'
	 */
	getURL: function(baseURL, optionnalParams) {
		var s = SOLVNET.urlPrefix + baseURL;
		if (optionnalParams)
			s = s + '?' + $.param(optionnalParams);
		return s;
	},

	/**
	 * Objet clef/valeur servant à la traduction et alimenté via les fichiers "langs/*.js" :
	 * <ul>
	 * <li>par défaut, les traductions se trouvant dans "webapp/langs/en.js"</li>
	 * <li>si précisé, le libellé pour la langue de l'utilisateur (fr ou de)</li>
	 * </ul>
	 */
	lang: {},

	/**
	 * Cette méthode incorpore dans la traduction "lang" les couples (clef, valeur) de "values".
	 * Le principe général est de faire : $.extend(SOLVNET.lang, values);
	 * Toutefois, le code de vérification des fichiers de traduction peut facilement être activé.
	 */
	addLang: function(lang, values) {
		/*
		var errors = 0, compare = function(path, reference, tested) {
			var missing = [];
			for (var p in reference) {
				var r = reference[p], t = tested[p];
				if (!t)
					missing.push(p);
				if (typeof r === 'object') {
					compare(path + p + '/', r, t);
				}
			}
			if (missing.length > 0) {
				console.log('[' + lang + '] Clefs manquantes dans ' + path, missing);
				errors += missing.length;
			}
		};

		if (lang !== 'en') {
			compare('/', SOLVNET.lang, values);
			console.log('[' + lang + '] ' + errors + ' erreur(s) de traduction');
			if (errors > 0)
				alert('[' + lang + '] ' + errors + ' erreurs de traduction');
		}
		*/
		$.extend(SOLVNET.lang, values);
	},

	/**
	 * Cette fonction traduit la clef donnée dans la langue en cours.
	 * Si la clef est suivi de paramètres ou d'un tableau de paramètre, elle formattera le message en appelant SOLVNET.formatMessage
	 *
	 * Par exemple, si la traduction initialise :
	 * <pre>
	 * SOLVNET.lang['Message'] = 'Coucou';
	 * SOLVNET.lang['Hello'] = 'Bonjour {1}, {2} fois';
	 * </pre>
	 *
	 * <ul>
	 * <li>L'appel SOLVNET.getLang('Message') retournera 'Coucou'</li>
	 * <li>L'appel SOLVNET.getLang('Hello', 'Invité', 3) retournera 'Bonjour Invité, 3 fois'</li>
	 * <li>L'appel SOLVNET.getLang('Hello', ['Invité', 3]) retournera aussi 'Bonjour Invité, 3 fois'</li>
	 * </ul>
	 *
	 * @param key la clef à traduire, éventuellement suivie de paramètres
	 * @returns la traduction de la clef, en substituant, les paramètres {1}, {2}, ... avec ce qui suit 'key'
	 */
	getLang: function(key) {
		var text = SOLVNET.lang[key] || key;
		if (arguments.length > 1) {
			var isArray = $.isArray(arguments[1]),
				params = isArray ? arguments[1] : Array.prototype.slice.call(arguments, 1, arguments.length);
			text = SOLVNET.formatMessage(text, params);
		}
		return text;
	},

	/**
	 * Cette fonction formatte un message en substituant {0}, {1}, ... par les paramètres à la suite de "text"
	 *
	 * Par exemple,
	 * <pre>
	 * SOLVNET.formatMessage('Bonjour {0}, {1} fois', 'Invité', 3)
	 * SOLVNET.formatMessage('Bonjour {0}, {1} fois', ['Invité', 3])
	 * </pre>
	 * retourneront tous les deux <code>'Bonjour Invité, 3 fois'</code>
	 *
	 * @param text le message à formatter, contenant des {0}, {1}, ...
	 * @returns le message formatté, en substituant {0}, {1}, ... par les paramètres à la suite de "text"
	 */
	formatMessage: function(text) {
		if (arguments.length > 1) {
			// Quand on appelle formatMessage('...', param1, param2, ...), on itère "arguments" à partir de 1
			// Quand on appelle formatMessage('...', [param1, param2, ...]), on itère "arguments[1]" à partir de 0
			var isArray = $.isArray(arguments[1]),
				params = isArray ? arguments[1] : arguments,
				offset = isArray ? 0 : 1;
			for (var i = offset; i < params.length; i++) {
				text = text.replace('{' + (i - offset) + '}', params[i]);
			}
		}
		return text;
	},

	/** Cette méthode affiche une liste d'erreurs à l'utilisateur */
	showErrors: function(errors) {
		errors.forEach(SOLVNET.showError);
	},

	/** Cette méthode affiche un message d'erreur à l'utilisateur */
	showError: function(message) {
		SOLVNET.showMessage(message, true, 0);
	},

	/** Cette méthode affiche un message de réussite à l'utilisateur */
	showSuccess: function(message) {
		SOLVNET.showMessage(message, false, 4000);
	},

	/**
	 * Cette méthode affiche un message à l'utilisateur, avec possibilité d'activer un bouton à droite
	 */
	showMessage: function(message, error, duration, details, button, callback) {
		var snackbar = {
			message: message,
			error: !!error,
			duration: duration
		};
		if (details)
			snackbar.details = details;
		if (button)
			snackbar.button = button;
		if (callback)
			snackbar.callback = callback;
		$.materialSnackbar(snackbar);
	},

	/**
	 * Cette méthode indique au serveur le type de périphérique de l'utilisateur
	 */
	registerDevice: function() {
		var registerCalledWhileOffline = false;
		var registerDeviceTimeout = null;
		function registerDeviceInfo() {
			// En mode hybride, le serveur n'est pas accessible donc on zappe l'appel.
			// Toutefois, on note ce point pour lancer le "GET" quand on récupère l'accès.
			if (! SOLVNET.online) {
				registerCalledWhileOffline = true;
				return;
			}
			$.get(SOLVNET.getURL('layout/device'), {
				width: window.innerWidth,
				height: window.innerHeight,
				pixelRatio: Math.round(window.devicePixelRatio * 100),
				touchEnabled: ('ontouchstart' in document.body)
			});
		}
		// Appeler une fois au chargement de la page
		registerDeviceInfo();
		// Appeler en cas de redimensionnement de la page (acvec timeout pour éviter de surcharger d'appels)
		$(window).on('resize', function() {
			if (registerDeviceTimeout)
				clearTimeout(registerDeviceTimeout);
			registerDeviceTimeout = setTimeout(function() {
				if (registerDeviceTimeout !== null) {
					registerDeviceTimeout = null;
					registerDeviceInfo();
				}
			}, 200);
		});
		// Appeler quand on récupère l'accès au serveur, si un appel a été bloqué en mode hybride
		$(window).on('solvnet.onlinechange', function() {
			if (SOLVNET.online && registerCalledWhileOffline) {
				registerCalledWhileOffline = false;
				registerDeviceInfo();
			}
		});
	},

	/**
	 * Cette méthode affiche le message donné à l'utilisateur afin de lui demander confirmation.
	 * Si l'utilisateur confirme, la fonction donnée est appelée.
	 *
	 * Les différences notables avec "window.confirm" sont :
	 * - le comportement est asynchrone
	 * - l'utilisateur ne pourra pas par erreur demander à masquer les messages
	 * - les actions "dangereuses" sont mises en évidence grâce à "danger=true"
	 *
	 * @param {boolean} danger - indique si l'action est dangereuse (true) ou non (false)
	 * @param {boolean} html - indique si le message est en HTML (true) ou en texte brut (false)
	 * @param {String} message - le message de confirmation à afficher
	 * @param {function} callbackConfirm - la fonction sans paramètre à appeler si l'utilisateur confirme
	 * @param {function} callbackCancel - la fonction sans paramètre à appeler si l'utilisateur annule
	 * @param {function} callbackResult - la fonction qui prendra en paramètre un boolean, true si confirmé, false si annulé
	 */
	confirm: function(danger, html, message, callbackConfirm, callbackCancel, callbackResult) {
		// On récupère la fenêtre de confirmation
		var dialog = $('#confirm-dialog');
		// Si elle n'existe pas (dans quel cas à part index.jsp ?), on utilise "window.confirm" à la place
		if (dialog.length === 0) {
			var confirmed = window.confirm(message);
			if (confirmed && callbackConfirm)
				callbackConfirm();
			if (!confirmed && callbackCancel)
				callbackCancel();
			if (callbackResult)
				callbackResult(confirmed);
		} else {
			// Sinon, on affiche le message avec l'importance demandée dans la fenêtre de confirmation
			var modal = dialog.find('.modal-body');
			if (html === true)
				modal.html(message);
			else
				modal.text(message);
			modal.toggleClass('text-danger', danger);
			// On récupère le bouton de confirmation pour lui donner l'importance demandée et attendre un clic
			dialog.find('#confirm-button').toggleClass('btn-danger', danger).toggleClass('btn-primary', !danger).off('click').on('click', function() {
				if (callbackConfirm)
					callbackConfirm();
				if (callbackResult)
					callbackResult(true);
				dialog.modal('hide');
			});
			// On écoute également le click sur le bouton cancel
			dialog.find('#cancel-button').off('click').on('click', function() {
				if (callbackCancel)
					callbackCancel();
				if (callbackResult)
					callbackResult(false);
				dialog.modal('hide');
			});

			// On peut afficher la demande de confirmation
			dialog.modal('show');
		}
	},

	/**
	 * Cette méthode affiche la fenêtre modale de modification de la note utilisateur.
	 */
	showNote: function() {
		$('#note-dialog').modal('show');
	},

	/**
	 * Cette méthode indique la page en cours dans l'onglet du navigateur ainsi que dans la barre supérieure
	 */
	showLocation: function(title) {
		var t = $('title');
		if (! t.attr('data-default-title'))
			t.attr('data-default-title', t.text());
		title = title || t.attr('data-default-title');
		$('#index-location').text(title);
		t.text(title);
	},

	/**
	 * Cette méthode demande l'affichage de l'URL donnée :
	 * - la navigation actuelle remplacera la page en cours par l'URL demandée
	 * - si on intégrait un navigation par onglet, on ouvrirait un onglet pour cette URL
	 * - si on souhaitait en plus que l'onglet soit unique, on rechercherait si l'URL est déjà ouverte avec d'ouvrir un nouvelle onglet
	 */
	showPage: function(url) {
		window.location = url;
	},

	/**
	 * Cette méthode permet au code JavaScript de remonter des traces côté serveur pour qu'ils apparaissent dans les logs récupérables par le support.
	 *
	 * @param {String} level - le niveau de log, parmi "fatal", "error", "warn", "info", "debug", "trace"
	 * @param {String} message - le message à tracer
	 * @param {Function} done - la fonction facultative à appeler quand c'est fait, peut importe le résultat
	 *
	 * @see Utiliser si besoin SOLVNET.formatMessage pour formatter un message avec paramètre(s)
	 */
	log: function(level, message, done) {
		var post = $.post(SOLVNET.getURL('app/log'), {
			level: level,
			message: message
		});
		if (typeof done === 'function')
			post.always(done);
	},

	/**
	 * Cette méthode :
	 * - récupère le paramétrage des mails (mail/settings?...)
	 * - utilise une lien "mailto:" si les mails ne sont pas actifs dans SOLVNet
	 * - s'assure que CKEDITOR est chargé (initCKEditor)
	 * - affiche ensuite le popin de saisie de mail ($.fn.materialPopinMail)
	 * - envoie enfin le mail quand l'utilisateur valide (SOLVNET.sendMail).
	 */
	openMail: function(model, objectId, marketId, customerId, configurationId, mailDatas) {
		mailDatas = mailDatas || {};
		// Récupérer les infos (mails de l'utilisateur, contacts de customerId et template de objectId)
		$.get(SOLVNET.getURL('mail/settings', {
			modelName: model,
			customerId: customerId,
			marketId: marketId,
			objectId: objectId,
			configurationId: configurationId
		}), function(data) {
			if (!data.mailAvailable) {
				// On utilise un lien "mailto:" quand la messagerie n'est pas accessible par SOLVNet
				var separator = '',
					mailtoCmd = 'mailto:';
				mailtoCmd += encodeURIComponent(mailDatas.sendTo || '');
				if (mailDatas.subject || mailDatas.content)
					mailtoCmd += '?';
				if (mailDatas.subject) {
					mailtoCmd += separator + 'subject=' + encodeURIComponent(mailDatas.subject);
					separator = '&';
				}
				if (mailDatas.content) {
					mailtoCmd += separator + 'body=' + encodeURIComponent(mailDatas.content);
					separator = '&';
				}
				// à compléter si d'autres option à prendre en compte
				window.open(mailtoCmd , '_self');
				return;
			}
			// S'assurer que CKEDITOR est chargé
			initCKEditor().then(function() {
				// Ouvrir le popin pour la saisie de mail
				$('<div />').materialPopinMail({
					lang: SOLVNET.getLang('Locale'),
					froms: data.froms,
					contacts: data.contacts,
					sendTo: mailDatas.sendTo || '',
					sendToMaxLength: 512, //MySQL varchar(512)
					sendCCMaxLength: 512, //MySQL varchar(512)
					sendBCC: (data.addBccOwnerEmail ? data.froms[0].email : ''),
					sendBCCMaxLength: 512, //MySQL varchar(512)
					replyToMaxLength: 512, //MySQL varchar(512)
					subject: mailDatas.subject || '',
					subjectMaxLength: 128, //MySQL varchar(128)
					content: mailDatas.content || '',
					contentMaxLength: 16777215, //MySQL MEDIUMTEXT
					attachments: data.attachments,
					error: SOLVNET.showError,
					addSignature: mailDatas.addSignature,
					execute: function(mail) {
						// Envoyer le mail par SOLVNet quand l'utilisateur valide l'envoi
						return SOLVNET.sendMail(mail, model, objectId, marketId, customerId, configurationId);
					},
					onaddContacts: function(contacts) {
						function addField(infoName, property, defaultCaption) {
							if (data.fieldsRights[infoName] && !!data.fieldsRights[infoName].visible)
								fields.push({
									property: property,
									caption: data.fieldsRights[infoName].caption || defaultCaption
								});
						}

						var def = $.Deferred();
						var fields = [
							{property: 'caption', caption: SOLVNET.getLang('ContactCaption')}
						];
						addField('contacts.email', 'email', SOLVNET.getLang('ContactEmail'));
						addField('contacts.function_id', 'function', SOLVNET.getLang('ContactFunctionId'));
						addField('contacts.department_ids', 'departments', SOLVNET.getLang('ContactDepartmentIds'));
						$('<div />').materialPopinSelectContact(contacts, fields, function(selectedContacts) {
							def.resolve(selectedContacts);
						}, function() {
							def.reject();
						});
						return def;
					}
				});
			});
		});
	},

	/**
	 * Cette méthode envoie au serveur le contenu d'un mail "mail", en indiquant à quelle donnée le rattacher
	 * (model, objectId) et le contexte (marketId, customerId) et retourne le "Deferred" de l'appel à  $.axax.
	 *
	 * @param mail - le mail à envoyer, tel que fournit par materialPopinMail
	 * @param model - le type de donnée à laquelle le mail est attaché (cf ECommonMailModel)
	 * @param objectId - l'identifiant de la donnée à laquelle le mail est attaché (client, linéaire, ...)
	 * @param marketId - le marché en cours, auquel le mail sera rattaché
	 * @param customerId - l'identifiant du client (pour connaitre les contacts)
	 * @param configurationId - l'identifiant de la configuration (pour appliquer les filtres sur la configuration)
	 * @return un Deferred obtenu suite à l'appel à $.ajax
	 */
	sendMail: function(mail, model, objectId, marketId, customerId, configurationId) {
		var attachmentIndex = 0;
		var formData = new FormData();
		formData.append('form.model', model);
		formData.append('form.objectId', objectId);
		formData.append('form.marketId', marketId);
		formData.append('form.customerId', customerId);
		formData.append('form.configurationId', configurationId);
		formData.append('form.contentIsHTML', mail.contentIsHTML === false ? false : true);
		['from', 'sendTo', 'sendCC', 'sendBCC', 'replyTo', 'subject', 'content'].forEach(function(field) {
			if (mail[field])
				formData.append('form.' + field, mail[field]);
		});
		if (mail.files) {
			mail.files.forEach(function(file) {
				var prefix = 'form.attachments.attachment' + (++attachmentIndex) + '.';
				formData.append(prefix + 'type', 'upload');
				formData.append(prefix + 'uploadFile', file);
			});
		}
		if (mail.attachments) {
			mail.attachments.forEach(function(attachment) {
				var prefix = 'form.attachments.attachment' + (++attachmentIndex) + '.';
				formData.append(prefix + 'type', attachment.type);
				if (attachment.type === 'attachment')
					formData.append(prefix + 'attachmentId', attachment.attachmentId);
				else //if (attachment.type === 'template')
					formData.append(prefix + 'templateName', attachment.templateName);
			});
		}
		return $.ajax({
			url: SOLVNET.getURL('mail/send'),
			type: 'POST',
			contentType: false, // enverra bien (1) en multipart/form-data, (2) en UTF-8 et (3) avec un "boundary" correctement défini
			processData: false,
			data: formData
		}).then(undefined, function(error) {
			return $.Deferred().reject(error.responseText);
		});
	},
	initSharePage: function(notification, message, sendMail, sendBccMail, userIds) {
		var context = $('#share-button').data('context'),
			section = $('#share-button').data('section'),
			page =  $('#share-button').data('page'),
			urlContext = {marketId: context.marketId},
			dynamicContext = {};

		for (var p in context) {
			if (context.saveProperties.indexOf(p) >= 0) {
				if (section.queryContextProperties.indexOf(p) >= 0)
					urlContext[p] = context[p];
				else
					dynamicContext[p] = context[p];
			}
		}

		notification.message = message;
		notification.sendMail = sendMail;
		notification.sendBccMail = sendBccMail;
		notification.userIds = userIds;
		notification.data = JSON.stringify({
			pageId: page.id,
			pageCaption: page.caption,
			urlContext: urlContext,
			dynamicContext: dynamicContext
		});
		notification.origin = window.location.origin;
	},
	getCartoAvailable: function() {return SOLVNET.cartoAvailable;},
	getBookAvailable: function() {return SOLVNET.bookAvailable;},
	getFeedbackAvailable: function() {return SOLVNET.feedbackAvailable;},
	promiseCustomer: null,
	/**
	 * Charger un client
	 * @param customerId Id du client
	 * @param marketId Id du marché
	 * @param needExecuteControlSelectDetail Nécessite l'éxecution du SelectDetail
	 * @return une promesse de client.
	 */
	getPromiseCustomer: function(customerId, marketId, needExecuteControlSelectDetail) {
		if (SOLVNET.promiseCustomer == null || SOLVNET.promiseCustomer.customerId !== customerId || SOLVNET.promiseCustomer.marketId !== marketId) {
			// Stocker le résultat pour le partager avec les autres tant que customerId et marketId restent les mêmes
			SOLVNET.promiseCustomer = {
				customerId: customerId,
				marketId: marketId,
				// Récupérer le client demandé pour le marché demandé
				promise: $.get(SOLVNET.getURL("customer/find/" + customerId, { 'marketId': marketId }))
			};

			// Centraliser l'affichage du message d'erreur
			SOLVNET.promiseCustomer.promise.fail(function error(error) {
				SOLVNET.showError(SOLVNET.getLang("CustomerFormFailedToLoad"));
			});
		}

		if(needExecuteControlSelectDetail) {
			if(! SOLVNET.promiseCustomer.promiseWithControlExecuted) {
				// Centraliser l'exécution des contrôles "SelectDetail" sur le client
				SOLVNET.promiseCustomer.promiseWithControlExecuted
					= SOLVNET.promiseCustomer.promise.then(function (customer) {
						var defer = $.Deferred();
						var c = ControlAPI.createCustomerContext(customer);
						ControlAPI.execute(ControlAPI.types.Customer, ControlAPI.actions.SelectDetail, c, function(result) {
							defer.resolve(customer);
						});
						return defer;
					});
			}
			return SOLVNET.promiseCustomer.promiseWithControlExecuted;
		}

		return SOLVNET.promiseCustomer.promise;
	},
	promiseProduct : null,
	/**
	 * Charger un produit
	 * @param productId Id du produit
	 * @param marketId Id du marché
	 * @param needExecuteControlSelectDetail Nécessite l'éxecution du SelectDetail
	 * @return une promesse de produit.
	 */
	getPromiseProduct: function(productId, marketId, needExecuteControlSelectDetail) {
		if (SOLVNET.promiseProduct == null || SOLVNET.promiseProduct.productId !== productId || SOLVNET.promiseProduct.marketId !== marketId) {
			// Stocker le résultat pour le partager avec les autres tant que productId et marketId restent les mêmes
			SOLVNET.promiseProduct = {
				productId: productId,
				marketId: marketId,
				// Récupérer le produit demandé pour le marché demandé
				promise: $.get(SOLVNET.getURL("product/find/" + productId, {'marketId': marketId}))
			};

			// Centraliser l'affichage du message d'erreur
			SOLVNET.promiseProduct.promise.fail(function error(error) {
				SOLVNET.showError(SOLVNET.getLang("ProductFormFailedToLoad"));
			});
		}

		if(needExecuteControlSelectDetail) {
			if(! SOLVNET.promiseProduct.promiseWithControlExecuted) {
				// Centraliser l'exécution des contrôles "SelectDetail" sur le produit
				SOLVNET.promiseProduct.promiseWithControlExecuted
					= SOLVNET.promiseProduct.promise.then(function success(product) {
						var defer = $.Deferred();
						var c = ControlAPI.createProductContext(product);
						ControlAPI.execute(ControlAPI.types.Product, ControlAPI.actions.SelectDetail, c, function(result) {
							defer.resolve(product);
						});
						return defer;
					});
			}
			return SOLVNET.promiseProduct.promiseWithControlExecuted;
		}
		return SOLVNET.promiseProduct.promise;
	},
	promiseVisitStatements: null,
	getPromiseVisitStatements: function(visitId) {
		if (SOLVNET.promiseVisitStatements == null || SOLVNET.promiseVisitStatements.visitId !== visitId) {
			var promise = $.get(SOLVNET.getURL("visit/getStatements/" + visitId));

			SOLVNET.promiseVisitStatements = {
				visitId: visitId,
				promise: promise
			};
		}
		return SOLVNET.promiseVisitStatements.promise;
	},
	promiseVisit : null,
	getPromiseVisit: function(visitId, customer, needExecuteControlSelectHeader) {
		if (SOLVNET.promiseVisit == null || SOLVNET.promiseVisit.visitId !== visitId) {
			// Stocker le résultat pour le partager avec les autres tant que visitId reste le même
			SOLVNET.promiseVisit = {
				visitId: visitId,
				// Récupérer la visite demandée
				promise: $.get(SOLVNET.getURL("visit/find/" + visitId))
			};

			// Centraliser l'affichage du message d'erreur
			SOLVNET.promiseVisit.promise.fail(function error(error) {
				SOLVNET.showError(SOLVNET.getLang("VisitFormFailedToLoad"));
			});

		}

		if(needExecuteControlSelectHeader) {
			if(! SOLVNET.promiseVisit.promiseWithControlExecuted) {
				// Centraliser l'exécution des contrôles "SelectHeader" sur la visite
				SOLVNET.promiseVisit.promiseWithControlExecuted
					= SOLVNET.promiseVisit.promise.then(function success(visit) {
						var defer = $.Deferred();
						if (!customer || customer.id !== visit.customerId) {
							defer.reject('pas le bon client');
						} else {
							 var getEventTypeIdDeferred = $.Deferred().resolve();
							 if (!visit.eventTypeId) {
								 getEventTypeIdDeferred = getEventTypeIdDeferred.then(function() {
									 return $.get(SOLVNET.getURL('planner/getEventTypeId', {eventId: visit.plannerEventId})).then(function(eventTypeId) {
										 visit.eventTypeId = eventTypeId;
									 });
								 });
							 }
							 getEventTypeIdDeferred.then(function() {
								var c = ControlAPI.createVisitContext(customer, visit);
								ControlAPI.execute(ControlAPI.types.Visit, ControlAPI.actions.SelectHeader, c, function(result) {
									defer.resolve(visit);
									// Vérifier si la validité de la visite change suite aux contrôles
									UTILS.visits.checkAfterStatementControl(c);
								});
							 });
						}
						return defer;
					});
			}
			return SOLVNET.promiseVisit.promiseWithControlExecuted;
		}

		return SOLVNET.promiseVisit.promise;
	},
	/**
	 * Variable interne qui aide la centralisation de la récupération de id de linéaire associé au visitId en cours.
	 * Utilisez exclusivement getPromiseLinearId pour y accéder.
	 */
	linearIdPromise : undefined,
	/**
	 * Instance servant de singleton pour s'assurer qu'il n'y a qu'une requête cliente qui part pour un visitId
	 * @param context
	 * @param create lance la création de linéaire.
	 */
	getPromiseLinearId: function (visitId, create) {
		if (SOLVNET.linearIdPromise && SOLVNET.linearIdPromise.visitId === visitId) {
			if(! (create && !SOLVNET.linearIdPromise.create))
				return SOLVNET.linearIdPromise.promise;
		}

		SOLVNET.linearIdPromise = {
			visitId: visitId,
			create: create,
		};

		if (! visitId) {
			SOLVNET.linearIdPromise.promise = $.Deferred().resolve(null);
			return SOLVNET.linearIdPromise.promise;
		}

		SOLVNET.linearIdPromise.promise = $.get(SOLVNET.getURL("linear/getLinearId/" + visitId, {create: create}))
		.then(function(data) {
			if(data.checkIsVisit) {
				// On vient de créer un linéaire, le paramétrage 'coche visite' est actif => on s'assure que le isVisit est bien coché.
				if (SOLVNET.promiseVisit && SOLVNET.promiseVisit.visitId === SOLVNET.linearIdPromise.visitId) {
					// il y a une visite en cours de chargé et elle correspond au linéaire qu'on vient de créer.
					SOLVNET.promiseVisit.promise.then(function(visit) {
						// On applique le isVisit.
						visit.isVisit = true;
						$(visit).trigger('solvnet.modelchange');
					});
				}
			}
			return data.linearId;
		});
		return SOLVNET.linearIdPromise.promise;
	},
	/**
	 * Objet servant de cache pour la récupération d'un linéaire.
	 * Il contient un objet:
	 * {
	 * 	visitId : id de la visite.
	 * 	promise : la promesse pour la récupération du linéaire chargé.
	 * }
	 * Vous ne devez jamais accéder directement à cet objet. Utilisez exclusivement getLinearPromise(context)
	 * qui se charge de récupérer le linéaire si il y a besoin.
	 */
	linearPromise : undefined,
	/**
	 * Cette fonction charge les données d'un linéaire (en-tête et detail) pour la session en cours.
	 * l'etiquette d'en-tête ou de détail appelle cette fonction. Mais seul la première etiquette l'ayant appelée charge
	 * les données.
	 */
	getPromiseLinear: function(linearId, customer, visit, needExecuteControlOpen) {
		if(visit.customerId !== customer.id) {
			throw "customerId:" + visit.customerId + " !== " +  visit.customerId;
		}

		if (!SOLVNET.linearPromise || SOLVNET.linearPromise.linearId !== linearId)  {
			SOLVNET.linearPromise = {
				linearId: linearId,
				promise: undefined
			};

			if(! linearId) {
				SOLVNET.linearPromise.promise = $.Deferred.resolve(null);
			} else {
				// on charge l'en-tete
				SOLVNET.linearPromise.promise = $.get(SOLVNET.getURL('linear/find/' + SOLVNET.linearPromise.linearId))
				.then(function(data) {
					if(data.nolinear) {
						SOLVNET.linearPromise.promise.resolve(null);
						return;
					}

					if(data.header.visitId !== visit.id) {
						SOLVNET.linearPromise.promise.reject(null);
						throw "Id visit:" + data.header.visitId + " !== " +  visit.id;
					}

					// Indiquer l'état modifiable du linéaire dans l'entete. Est utile pour les contrôles
					data.header.updatable = data.updatable;

					if(data.previous && data.previous.header) {
						data.header.previous = data.previous.header;

						var previousDetailMapByProductId = {};
						data.previous.rows.forEach(function(row) {
							previousDetailMapByProductId[row.productId] = row;
						});
						data.rows.forEach(function(row) {
							row.previous = previousDetailMapByProductId[row.product.id];

							if(row.previous) {
								// On réinjecte le produit car il n'est pas complet et çà peut manquer pour les calculs des linéaire (product.length)
								row.previous.product = row.product;
							}

						});
					}
					return data;
				}, function notifyFailed(error) {
					SOLVNET.showError(SOLVNET.getLang("LinearFormFailedToLoad"));
				});
			}
		}

		if(needExecuteControlOpen) {
			if(SOLVNET.linearPromise.promiseWithControlOpen === undefined) {
				SOLVNET.linearPromise.promiseWithControlOpen
					= SOLVNET.linearPromise.promise
					.then(function(data) {
						// Création du context de controller.
						var c = ControlAPI.createLinearContext(-1, customer, visit, data.header, undefined, data.rows);

						var promiseControlExecuted = $.Deferred();
						// JEROME Executer en SelectHeader mais il faut faire un
						// patch de migration des contrôles
						ControlAPI.execute(ControlAPI.types.Linear, ControlAPI.actions.Open, c, function(result) {
							if (c.modifications.length > 0 && c.modifications.includes(c.linearHeader)) {
								// Si il y a eu quelques choses de modifié, on
								// le sauvegarde
								SOLVNET.updateLinear(data)
								.then(function success() {

									promiseControlExecuted.resolve(data);

									// Vérifier si la validité de la visite
									// change suite aux contrôles
									UTILS.visits.checkAfterStatementControl(c);
								}, function failed() {
									SOLVNET.linearPromise.promise.reject('control creation save failed');
								});
							} else {
								promiseControlExecuted.resolve(data);
							}
						});

						// On retourne $.Deferred qui sera résolu plus tard.
						return promiseControlExecuted;
					});
			}
			return SOLVNET.linearPromise.promiseWithControlOpen;
		}
		return SOLVNET.linearPromise.promise;
	},
	/**
	 * S'occupe de sauvegarder un objet linéaire (en-tête & ses détails)
	 */
	updateLinear: function(linear) {
		// Liste des details à insérer ou à mettre à jour.
		var modified = [];

		// Liste des id des produit à conserver => Tt ce qui n'est pas dans cette liste et qui existe en base devra être supprimé.
		var productIds = [];


		linear.rows.forEach(function(row) {
			productIds.push(row.product.id);

			if(row.gridModified)  {
				// Soit la ligne est marqué comme modifié
				// Soit le linéaire est nouveau dans ce cas tout doit être sauvegardé.
				var linearDetailForm = {};
				// Copie la ligne dans linearDetailForm
				$.extend(linearDetailForm, row);
				// On copie la clé produit.
				linearDetailForm.productId = linearDetailForm.product.id;
				/* un peu de ménage pour n'envoyer que ce qui est essentiel
				 * et eviter coté serveur la perte de données causé par un nombre trop important de paramètre sur le connecteur HTTP
				 */
				linearDetailForm.product = undefined;
				linearDetailForm.previous = undefined;
				modified.push(linearDetailForm);
			}
		});
		var linearHeader = {};
		$.extend(linearHeader, linear.header);
		linearHeader.previous = undefined;

		var form  = {
				header: linearHeader,
				recalculateTypology: linear.recalculateTypology,
				productIds: productIds,
				rows: modified
			};
		return $.post(
				SOLVNET.getURL('linear/update/' + linear.linearId),
				{
					form: form
				}
		).then(function() {
			linear.rows.forEach(function(row) {
				delete row.gridModified;
			});
		});
	},
	getPromiseDeleteLinear: function(linearId) {
		// On vide les promises car on peut par erreur retravailler avec le linear qui se trouvait en cache.
		SOLVNET.linearIdPromise = undefined;
		SOLVNET.linearPromise = undefined;
		return $.get(SOLVNET.getURL('linear/delete/' + linearId));
	},
	getOrderDetailKey: function(orderDetail) {
		return orderDetail.packagingId + "," + orderDetail.productId;
	},
	promiseOrder : null,
	getPromiseOrder:  function(orderId, customer, visit, linear, needExecuteControlOpen) {
		/**
		 * Il y a une requête qui se charge de récupérer le paramétrage de l'en-tête & le détail d'une commande.
		 * Deux raisons :
		 * 1) pouvoir partager la sauvegarde en-tête & détail quand on déclenche une copie.
		 * car la multi copie de promotion va engendrer des modifications dans le détail & l'en-tête.
		 * Si on ne fait pas çà , on va être obligé de gérer des cas compliqué de mise à jour sans l'en-tête ou sans le détail
		 * 2) Cela facilitera la conception des contrôles et de l'application de leur sauvegarde.
		 * Ex : J'ai un contrôle qui met la colonne A en rouge du détail quand l'info d'en-tête theme est sur "MegaPromo"
		 */
		if (SOLVNET.promiseOrder === null || SOLVNET.promiseOrder.orderId !== orderId) {
			SOLVNET.promiseOrder = {
					orderId: orderId,
					promise: $.get(SOLVNET.getURL('order/find/' + orderId)).then(function(order) {
						// Mapper les lignes de commandes en objets métiers OrderDetail et sous-objets métiers VisitOrderDetailFields
						order.details = order.details.map(rowOrderDetailConformity);
						// Indiquer l'état modifiable de la commande dans l'entete. Est utile pour les contrôles
						order.header.updatable = order.updatable;

						// Jonction du linearDetail au orderDetail.
						if(linear) {
							var linearDetailByProductId = {};
							linear.rows.forEach(function(linearDetail) {
								linearDetailByProductId[linearDetail.product.id] = linearDetail;
							});
							order.details.forEach(function(orderDetail) {
								orderDetail.linearDetail = linearDetailByProductId[orderDetail.product.id];
							});
						}
						return order;
					},
					function() {
						SOLVNET.showError(SOLVNET.getLang("OrderFormFailedToLoad"));
					}
				)
			};
		}

		if(needExecuteControlOpen) {
			if(! SOLVNET.promiseOrder.promiseWithControlExecuted) {
				// Centraliser l'exécution des contrôles "Open" sur la commande
				SOLVNET.promiseOrder.promiseWithControlExecuted
					= SOLVNET.promiseOrder.promise.then(function success(order) {
						var defer = $.Deferred();

						// Création du context de controller.
						var c = ControlAPI.createOrderContext(-1, customer, visit, order.header, undefined, linear ? linear.header : null,  order.details);

						//JEROME Executer en SelectHeader mais il faut faire un patch de migration des contrôles
						ControlAPI.execute(ControlAPI.types.Order, ControlAPI.actions.Open, c, function(result) {
							if (c.modifications.length > 0 && c.modifications.includes(c.orderHeader)) {
								// Si il y a eu quelques choses de modifié, on le sauvegarde
								SOLVNET.updateOrder(order)
								.then(function success() {
									// Lance ceux qui attendait après cette promise.
									defer.resolve(order);

									// Vérifier si la validité de la visite change suite aux contrôles
									UTILS.visits.checkAfterStatementControl(c);
								});

							} else {
								// Lance ceux qui attendait après cette promise.
								defer.resolve(order);
							}
						});

						return defer;
					});
			}
			return SOLVNET.promiseOrder.promiseWithControlExecuted;
		}

		return SOLVNET.promiseOrder.promise;
	},
	updateOrder: function(order) {
		// Liste des details à insérer ou à mettre à jour.
		var modified = [];

		// Liste des id des produit à conserver => Tt ce qui n'est pas dans cette liste et qui existe en base devra être supprimé.
		var keys = [];

		order.details.forEach(function(row) {
			keys.push(row.packagingId + "," + row.productId);

			if(row.gridModified)  {
				var orderDetailForm = {};

				// Copie la ligne dans orderDetailForm, j'utilise cette méthode car JQuery va se planter sur la serialisation, il va aller chercher
				// les valeurs des fonctions prototypes.
				UTILS.object.cloneProperties(orderDetailForm, row);

				// On supprime un objet inutile.
				orderDetailForm.product = undefined;
				orderDetailForm.linearDetail = undefined;
				modified.push(orderDetailForm);
			}
		});

		var form  = {
				header: order.header,
				keys: keys,
				rows: modified
			};
		return $.post(SOLVNET.getURL('order/update/' + order.header.id), { form: form })
		.then(function(order) {
			modified.forEach(function(row) {
				delete row.gridModified;
			});
		});
	},
	getPromiseDeleteOrder: function(orderId) {
		// On vide les promises car on peut par erreur retravailler avec un crv en cache
		if (SOLVNET.promiseOrder && SOLVNET.promiseOrder.orderId === orderId) {
			SOLVNET.promiseOrder = undefined;
		}
		return $.get(SOLVNET.getURL('order/delete/' + orderId));
	},
	promiseOffer : null,
	getPromiseOffer: function(offerId, marketId, withSelectHeaderExecution) {
		if (SOLVNET.promiseOffer === null || SOLVNET.promiseOffer.offerId !== offerId) {
			SOLVNET.promiseOffer = {
					offerId: offerId,
					promise: $.get(SOLVNET.getURL('offer/find/' + offerId, { marketId: marketId }))
						.then(function(resultOffer) {
							var offerHeaders = ModelAPI.jsonOfferHeaderListToOfferHeaderList(resultOffer.headers);
							var rows = ModelAPI.offerHeaderListToOfferHeaderRowList(offerHeaders);
							// On complémente l'objet des propriétés nécessaires après sa construction
							if (resultOffer.updatable === false) {
								rows.forEach(function(row) {
									row.updatable = false;
								});
							}
							resultOffer.header = UTILS.array.findById(rows, offerId);
							return resultOffer;
						},function() {
							SOLVNET.showError(SOLVNET.getLang("OfferFailedToLoad"));
						})
			};
		}

		if(withSelectHeaderExecution) {
			if(! SOLVNET.promiseOffer.promiseWithControlExecuted) {
				// Centraliser l'exécution des contrôles "Open" sur la commande
				SOLVNET.promiseOffer.promiseWithControlExecuted
					= SOLVNET.promiseOffer.promise.then(function success(resultOffer) {
						var defer = $.Deferred();

						// Création du contexte de controleur Promo
						var c = ControlAPI.createOfferContext(-1, resultOffer.header, undefined, resultOffer.details);
						ControlAPI.execute(ControlAPI.types.Offer, ControlAPI.actions.SelectHeader, c, function(result) {
							UTILS.offers.checkAfterStatementControlOfferScopeChanged(c);

							if (c.modifications.length > 0 && c.modifications.includes(c.offerHeader)) {
								// Modification détectée, on sauvegarde
								SOLVNET.updateOffer(resultOffer.header, resultOffer.details)
								.then(function success() {
									// Lance ceux qui attendait après cette promise.
									defer.resolve(resultOffer);
								});
							} else {
								// Lance ceux qui attendait après cette promise.
								defer.resolve(resultOffer);
							}
						});

						return defer;
				});
			}
			return SOLVNET.promiseOffer.promiseWithControlExecuted;
		}
		return SOLVNET.promiseOffer.promise;
	},
	promiseOfferSettings: null,
	getPromiseOfferSettings: function(marketId) {
		if (SOLVNET.promiseOfferSettings && SOLVNET.promiseOfferSettings.marketId === marketId) {
			return SOLVNET.promiseOfferSettings.promise;
		}
		SOLVNET.promiseOfferSettings = {
				marketId: marketId,
				promise: $.get(SOLVNET.getURL('offer/settings', { marketId: marketId }))
		};
		return SOLVNET.promiseOfferSettings.promise;
	},
	updateOffer: function(header, details) {
		// Liste des details à insérer ou à mettre à jour.
		var modified = [];

		var form = {};
		if(header instanceof ModelAPI.OfferHeaderRow) {
			// cloneProperties est nécessaire car sinon les objets(CustomerScope) rentre en conflit avec la serialisation en paramètre POST.
			form.header = UTILS.object.cloneProperties({}, header.header);
		} else {
			//JEROME "A retirer car à terme, on aura que le bon type"
			console.error("A retirer car à terme, on aura que le bon type");
			form.header = UTILS.object.cloneProperties({}, header);
		}

		// Envoyer l'univers sous forme de string car l'objet est complexe et sera décodé par Gson, pas pas WebMotion
		if (form.header.customerScope)
			form.header.customerScope = JSON.stringify(form.header.customerScope);

		// Liste des id des produit à conserver => Tt ce qui n'est pas dans cette liste et qui existe en base devra être supprimé.
		if(details) {
			// Liste des clés de détails à conserver.
			var keys = [];
			details.forEach(function(row) {
				keys.push(row.productId);
				if (row.gridModified)  {
					var offerDetailForm = {};
					// Copie la ligne dans offerDetailForm, j'utilise cette méthode car JQuery va se planter sur la serialisation, il va aller chercher
					// les valeurs des fonctions prototypes.
					UTILS.object.cloneProperties(offerDetailForm, row);
					// On supprime un objet inutile.
					offerDetailForm.product = undefined;
					modified.push(offerDetailForm);
				}
			});
			form.keys = keys;
			form.rows = modified;
			form.updateDetails = true;
		} else {
			form.updateDetails = false;
		}

		if(header.isNew) {
			return $.post(SOLVNET.getURL('offer/insert/' + header.id), { form: form })
					.then(function(r) {
						header.isNew = false;
						return r;
					});
		}
		return $.post(
			SOLVNET.getURL('offer/update/' + header.id), { form: form })
		.then(function() {
			modified.forEach(function(row) {
				delete row.gridModified;
			});
		});
	},
	promiseTypology : null,
	getPromiseTypology: function(typologyId, marketId, header) {
		if (SOLVNET.promiseTypology && SOLVNET.promiseTypology.typologyId === typologyId) {
			return SOLVNET.promiseTypology.promise;
		}

		SOLVNET.promiseTypology = {
			typologyId: typologyId,
			promise: $.Deferred()
		};

		if (! typologyId) {
			SOLVNET.promiseTypology.promise.resolve(null);
			return SOLVNET.promiseTypology.promise;
		}
		var typologyResult = {};
		$.get(
			SOLVNET.getURL('typology/find/' + typologyId, {marketId: marketId, loadHeader: header})
		).done(function(result) {
			typologyResult = result;
			SOLVNET.promiseTypology.promise.resolve(typologyResult);
		}).fail(function() {
			SOLVNET.showError(SOLVNET.getLang("TypologyFailedToLoad"));
		});
		return SOLVNET.promiseTypology.promise;
	},
	visitReportIdPromise: null,
	getPromiseVisitReportId: function(context, create) {
		if (SOLVNET.visitReportIdPromise && SOLVNET.visitReportIdPromise.visitId === context.visitId) {
			if(! (create && !SOLVNET.visitReportIdPromise.create))
				return SOLVNET.visitReportIdPromise.promise;
		}

		SOLVNET.visitReportIdPromise = {
			visitId: context.visitId,
			create: create
		};

		if (!context.visitId) {
			context.updateContextAndTriggerContextChangeEvent({visitReportId : undefined});
			SOLVNET.visitReportIdPromise.promise = $.Deferred().resolve(null);
			return SOLVNET.visitReportIdPromise.promise;
		}

		SOLVNET.visitReportIdPromise.promise = $.get(SOLVNET.getURL("visitreport/getVisitReportId/" + context.visitId, {create: create}))
		.then(function(data) {
			if(data.checkIsVisit) {
				// On vient de créer un CRV, le paramétrage 'coche visite' est actif => on s'assure que le isVisit est bien coché.
				if (SOLVNET.promiseVisit && SOLVNET.promiseVisit.visitId === SOLVNET.visitReportIdPromise.visitId) {
					// il y a une visite en cours de chargé et elle correspond au CRV qu'on vient de créer.
					SOLVNET.promiseVisit.promise.then(function(visit) {
						// On applique le isVisit.
						visit.isVisit = true;
						$(visit).trigger('solvnet.modelchange');
					});
				}
			}
			return data.visitReportId;
		});

		return SOLVNET.visitReportIdPromise.promise;
	},
	visitReportPromise : null,
	getPromiseVisitReport : function(visitReportId, customer, visit, withExecuteControlOpen) {
		if (SOLVNET.visitReportPromise  == null || SOLVNET.visitReportPromise.visitReportId !== visitReportId) {
			// Sinon on en crée une

			var promiseReportDetailInfos = SETTINGS.getReportDetailInfos().then(function(infoDefinitions) {
				return UTILS.array.mapById(infoDefinitions);
			});

			SOLVNET.visitReportPromise = {
				visitReportId: visitReportId,
				promise: $.get(SOLVNET.getURL('visitreport/find/' + visitReportId))
					.then(function(visitReport) {
						return promiseReportDetailInfos.then(function(infoDefinitionsById) {
							// On transforme les ligne de détails json en des objets métiers avec des getter/setter.
							visitReport.details = visitReport.details.map(function(d) {return new ModelAPI.VisitReportDetail(d, infoDefinitionsById[d.infoId]);});
							return visitReport;
						});
					})
			};
		}

		if(withExecuteControlOpen) {
			if(! SOLVNET.visitReportPromise.promiseWithControlExecuted) {
				// Centraliser l'exécution des contrôles "Open" sur la commande
				SOLVNET.visitReportPromise.promiseWithControlExecuted
					= SOLVNET.visitReportPromise.promise.then(function success(visitReport) {
						var defer = $.Deferred();

						var c = ControlAPI.createVisitReportContext(-1, customer, visit, visitReport, undefined, visitReport.details);
						ControlAPI.execute(ControlAPI.types.Report, ControlAPI.actions.Open, c, function(result) {
							if(c.modifications.length > 0) {
								if(SOLVNET.applyModificationsOnVisitReport(visitReport, c.modifications)) {
									SOLVNET.updateVisitReport(visitReport)
									.then(
										function() {
											defer.resolve(visitReport);
											SOLVNET.visitReportPromise.promise.resolve(visitReport);
										},
										function() {
											SOLVNET.showError(SOLVNET.getLang("VisitReportFormFailedToSave"));
											defer.resolve(visitReport);
										}
									);
									return;
								}
							}
							defer.resolve(visitReport);

							// Vérifier si la validité de la visite change suite aux contrôles
							UTILS.visits.checkAfterStatementControl(c);
						});

						return defer;
					});
			}
			return SOLVNET.visitReportPromise.promiseWithControlExecuted;
		}
		return SOLVNET.visitReportPromise.promise;
	},
	/**
	 * Fonction d'aide aux contrôles pour appliquer le statut de modification au détail des rapports de visites pour la gestion via updateVisitReport
	 * @return True, si l'en-tête ou un des détails a été modifié.
	 */
	applyModificationsOnVisitReport: function(visitReport, modifications) {
		var count = modifications.includes(visitReport) ? 1 : 0;
		visitReport.details.forEach(function(detail) {
			if(modifications.includes(detail)) {
				detail.modified = true;
				count++;
			}
		});
		return count;
	},
	updateVisitReport: function(visitReport) {
		var updates = $.map(visitReport.details, function(row) {
			return (! row.modified) ? undefined : {
				infoId: row.infoId,
				val: row.val,
				done: row.done,
				comments: row.comments,
				isPlanned: row.isPlanned,
				isPlannedComments: row.isPlannedComments
			};
		});

		var form = {
			code: visitReport.code,
			comments: visitReport.comments,
			valid: visitReport.valid
		};
		if(updates && updates.length > 0) {
			form.rows = updates;
		}

		return $.post(
				SOLVNET.getURL('visitreport/update/' + visitReport.visitReportId),
				{ form: form }
		).then(function success() {
			visitReport.details.forEach(function(r) {
				delete r.modified;
			});
		});
	},
	getPromiseDeleteVisitReport: function(visitReportId) {
		// On vide les promises car on peut par erreur retravailler avec un crv en cache
		SOLVNET.visitReportIdPromise = undefined;
		SOLVNET.visitReportPromise = undefined;
		return $.get(SOLVNET.getURL('visitreport/delete/' + visitReportId));
	},
	promiseOrderStatus: null,
	getPromiseOrderStatus: function() {
		if(! SOLVNET.promiseOrderStatus) {
			SOLVNET.promiseOrderStatus = $.get(SOLVNET.getURL("order/status/lookup"));
		}
		return SOLVNET.promiseOrderStatus;
	},
	promiseFeedback : null,
	getPromiseFeedback: function(context) {
		if (SOLVNET.promiseFeedback && SOLVNET.promiseFeedback.feedbackId === context.feedbackId) {
			return SOLVNET.promiseFeedback.promise;
		}

		SOLVNET.promiseFeedback = {
			feedbackId: context.feedbackId,
			promise: $.Deferred()
		};

		if (! context.feedbackId) {
			SOLVNET.promiseFeedback.promise.resolve(null);
			return SOLVNET.promiseFeedback.promise;
		}
		var feedbackResult = {};
		$.get(
			SOLVNET.getURL('feedback/find/' + context.feedbackId, {marketId: context.marketId, customerId: context.feedback ? context.feedback.customerId : null})
		).done(function(result) {
			feedbackResult = result;
			if (!feedbackResult.feedback && context.feedback) {
				feedbackResult.feedback = context.feedback;
			}
			SOLVNET.promiseFeedback.promise.resolve(feedbackResult);
		}).fail(function() {
			SOLVNET.showError(SOLVNET.getLang("FeedbackFailedToLoad"));
		});
		return SOLVNET.promiseFeedback.promise;
	},
	promiseFeedbackStatus: null,
	getPromiseFeedbackStatus: function() {
		if(! SOLVNET.promiseFeedbackStatus) {
			SOLVNET.promiseFeedbackStatus = $.get(SOLVNET.getURL("feedback/status/lookup"));
		}
		return SOLVNET.promiseFeedbackStatus;
	},
	/**
	 * Gestion des actions "onbuild" saisies éventuellement lors de la configuration des LayoutItem.
	 * Les fonctions disponibles sont définies dans "loadLayoutActions", qui se trouve dans "layout.js".
	 */
	onbuild: {},
	/**
	 * Gestion des actions "onclick" saisies éventuellement lors de la configuration des LayoutItem.
	 * Les fonctions disponibles sont définies dans "loadLayoutActions", qui se trouve dans "layout.js".
	 */
	onclick: {}
};

/**
 * UTILS nous fournit un ensemble de fonction utiles, regroupées par dommain, par exemple avec UTILS.array.*
 */
var UTILS = {
	functions: {
		identity: function(a) { return a; },
		allTrue: function() { return true; },
		allFalse: function() { return false; },
		todo: function() { throw new Error('TODO'); },
		empty: function() {},
		autoselectonfocus: function(event) {
			/* 
			 * Les input de type 'email' ne supportent pas selectionStart.
			 * On peut tricher en changeant temporairement le type de l'input.
			 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
			 */
			var hasEmailType = 'email' === $(event.target).attr('type');
			if (hasEmailType)
				$(event.target).attr('type', 'text');
			event.target.selectionStart = 0; event.target.selectionEnd = event.target.value.length;
			if (hasEmailType)
				$(event.target).attr('type', 'email');
		}
	},
	number: {
		between: BaseAPI.numberBetween,
		max: function(array, property) {
			return UTILS.number.mathFunction(array, property, 'max', Number.NEGATIVE_INFINITY);
		},
		min: function(array, property) {
			return UTILS.number.mathFunction(array, property, 'min', Number.POSITIVE_INFINITY);
		},
		mathFunction: function(array, property, functionName, initialValue) {
			if (array.length === 0)
				return null;
			return array.reduce(function(currentValue, entry) {
				return Math[functionName](currentValue, property ? entry[property] : entry);
			}, initialValue);
		},
		trunc : function(v) {
			return v >= 0 ? Math.floor(v) : Math.ceil(v);
		}
	},
	object: {
		/**
		 * Cette méthode retourne true si "a" et "b" peuvent être considérés identiques :
		 * - null / null
		 * - 2 nombres dont la différence est minime (< 0.0001)
		 * - 2 objets strictement égaux par '==='
		 */
		equalsOrEquivalentNumbers: function(a, b) {
			if (a === null)
				return b === null;
			if (typeof a === 'number')
				return (typeof b === 'number') && (Math.abs(a - b) < 0.0001);
			return a === b;
		},
		/**
		 * Cette méthode extraite du "moment.js" renvoie true si l'objet passé en paramètre est un objet de "Moment"
		 */
		isMoment: function(obj) {
			return obj instanceof moment || (obj != null && obj._isAMomentObject != null);
		},
		/**
		 * Cette méthode est l'équivalent de IDataType.compare, utilisée par exemple dans les aggrégateurs
		 */
		compare: function(value1, value2) {
			// Gestion des null
			if ((value1 === null) && (value2 === null))
				return 0;
			if (value1 === null)
				return -1;
			if (value2 === null)
				return 1;
			// Transformation des objets Moment.js en entier comparable
			// TODO : a priori pas utile d'après Mozilla (les opérateurs < <= >= et > appellent eux-mêmes valueOf())
			// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators#Relational_operators
			if (UTILS.object.isMoment(value1)) {
				value1 = value1.valueOf();
				value2 = value2.valueOf();
			}
			// Renvoyer -1, 0 ou 1 selon les cas
			return (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
		},
		/**
		 * Cette méthode vide les propriétés de "obj" et renvoie "obj" pour pouvoir chainer.
		 * Par exemple : UTILS.object.reset({ foo: 'bar', toto: null}) renvoie l'équivalent de {}
		 */
		reset: function(obj) {
			for (var p in obj) {
				if (obj.hasOwnProperty(p))
					delete obj[p];
			}
			return obj;
		},
		/**
		 * Cette méthode copie dans "dst" les propriétés "propertyNames" extraites de l'objet "src" et renvoie "dst".
		 * Par exemple : UTILS.object.inject({}, context, ['marketId', 'customerId'])
		 */
		inject: function(dst, src, propertyNames) {
			propertyNames.forEach(function(name) {
				dst[name] = src[name];
			});
			return dst;
		},
		/**
		 * Cette méthode crée un object composé des propriétés "propertyNames" extraites de l'objet "src"
		 * Par exemple : UTILS.object.extract(context, ['marketId', 'customerId'])
		 * Equivalent à : UTILS.object.inject({}, context, ['marketId', 'customerId']);
		 */
		extract: function(src, propertyNames) {
			return UTILS.object.inject({}, src, propertyNames);
		},
		/**
		 * Cette méthode remplace tout le contenu de "dst" par le contenu de "src" et renvoie "dst".
		 * Permet de récupérer un object côté serveur et de l'injecter dans l'objet côté client en gardant la même référence
		 * Par exemple : $.post('...', {customer: row}).done(function(newCustomer) { UTILS.object.replace(row, newCustomer); });
		 */
		replace: function(dst, src) {
			UTILS.object.reset(dst); // on vide
			$.extend(dst, src); // avant de remplir
			return dst;
		},
		/**
		 * Cette méthode clone un objet sans ses fonctions  (contrairement à $.extend). Elle opère aussi sur les sous propriété.
		 * Ce type de transformation est nécessaire pour des sérialisations d'objet en formulaire par JQuery
		 * Ce dernier va jusqu'à appeler les méthodes public des objets mais sans le contexte "this" approprié de l'objet.
		 */
		cloneProperties: function(dst, src) {
			function cloneArray(arraySrc) {
				return arraySrc.map(function(s) {
					if(typeof s === 'string' || typeof s === 'number')
						return s;
					else if(s  instanceof Array)
						return cloneArray(s);

					// Object
					return UTILS.object.cloneProperties({}, s);
				});
			}

			for (var p in src) {
				if (src.hasOwnProperty(p) && typeof src[p] !== 'function') {
					if(src[p] instanceof Array) {
						dst[p] = cloneArray(src[p]);
					} else if(src[p] instanceof Object) {
						dst[p] = UTILS.object.cloneProperties({}, src[p]);
					} else {
						dst[p] = src[p];
					}
				}
			}
			return dst;
		}
	},
	subObjectProperty: {
		/** Cette méthode ajuste tous les champs de "fields" en les décalant dans un sous objet via "subObjectProperty" */
		setOnFields: function(fields, subObjectProperty) {
			fields.forEach(function(field) {
				if (field.subObjectProperty) {
					field.subObjectProperty = subObjectProperty + "." + field.subObjectProperty;
				} else {
					field.subObjectProperty = subObjectProperty;
				}
			});
		},
		/**
		 * Cette méthode retourne la propriété "subObjectProperty" de l'objet "src" et, si absent, y injecte un nouvel objet :
		 * - "subObjectProperty" ne peut pas être vide
		 * - "subObjectProperty" ne peut pas contenir un chemin (voir "transform" pour utiliser un chemin)
		 * - si "row[subObjectProperty]" n'existe pas, un objet vide est créé et injecter
		 */
		get: function (src, subObjectProperty) {
			var result = src[subObjectProperty];
			if (! result) {
				result = {};
				src[subObjectProperty] = result;
			}
			return result;
		},
		/**
		 * Cette méthode applique le comportement de "subObjectProperty" à un objet "row" pour obtenir l'objet souhaité :
		 * - si "subObjectProperty" est vide, on retourne "row"
		 * - si "subObjectProperty" est "calculatedInformation", on retourne "row['calculatedInformation']"
		 * - si "subObjectProperty" est "customer.calculatedInformation", on retourne "row['customer']['calculatedInformation']"
		 */
		transform: function(row, subObjectProperty) {
			var self = this;
			// Si 'subObjectProperty' n'est pas définie, on retourne row
			if (!subObjectProperty)
				return row;
			// Le plus souvent, 'subObjectProperty' est le nom d'un sous-objet de 'row'
			// contenant les valeurs de la colonne (par exemple 'extendedInformation')
			if (subObjectProperty.indexOf('.') === -1)
				return self.get(row, subObjectProperty);
			// Toutefois, si 'subObjectProperty' peut représenter un chemin (par exemple
			// 'customer.extendedInformation'), la transformation est un peu + complexe
			subObjectProperty = subObjectProperty.split('.');
			var result = row;
			for (var i = 0; i < subObjectProperty.length; i++) {
				result = self.get(result, subObjectProperty[i]);
			}
			return result;
		},
		/**
		 * Cette méthode applique le comportement de "subObjectProperty" et retourne une fonction de transofmration (row)=>objet souhaité
		 * - si "subObjectProperty" est vide, on retourne une fonction (row)->row
		 * - si "subObjectProperty" est "calculatedInformation", on retourne une fonction (row)->row['calculatedInformation']
		 * - si "subObjectProperty" est "customer.calculatedInformation", on retourne une fonction (row)->row['customer']['calculatedInformation']
		 */
		transformMethod: function(subObjectProperty) {
			var self = this;
			// Si 'subObjectProperty' n'est pas définie, on retourne row
			if (!subObjectProperty)
				return UTILS.functions.identity;
			// Le plus souvent, 'subObjectProperty' est le nom d'un sous-objet de 'row'
			// contenant les valeurs de la colonne (par exemple 'extendedInformation')
			if (subObjectProperty.indexOf('.') === -1)
				return function(row) { return self.get(row, subObjectProperty); };
			// Toutefois, si 'subObjectProperty' peut représenter un chemin (par exemple
			// 'customer.extendedInformation'), la transformation est un peu + complexe
			subObjectProperty = subObjectProperty.split('.');
			return function(row) {
				var result = row;
				for (var i = 0; i < subObjectProperty.length; i++) {
					result = self.get(result, subObjectProperty[i]);
				}
				return result;
			};
		},
	},
	string: {
		fileExtension: BaseAPI.stringFileExtension,
		toTimeMS: function(s, momentFormat) {
			return s ? moment(s, momentFormat).valueOf() : undefined;
		},
		isEmpty: function(s) {
			return s === undefined || s === null || s.length === 0 || (s.trim().length === 0);
		}
	},
	array: {
		addIfNotFound: function(array, o) {
			// Search item
			var found = array.some(function(item) {
				return UTILS.object.compare(item, o) === 0;
			});
			// Filter dupplicates
			if (!found)
				array.push(o);
		},
		remove: BaseAPI.arrayRemove,
		mapByIn: function(result, array, property) {
			array.forEach(function(value) {
				result[value[property]] = value;
			});
			return result;
		},

		mapBy: function(array, property) {
			return UTILS.array.mapByIn({}, array, property);
		},
		containsBy: function(array, property, value) {
			return -1 !== UTILS.array.findIndexBy(array, property, value);
		},
		findBy: function(array, property, value) {
			var index = UTILS.array.findIndexBy(array, property, value);
			return index === -1 ? undefined : array[index];
		},
		findByValues: function(array, property, values) {
			return values.map(function(value) {
				return UTILS.array.findBy(array, property, value);
			});
		},
		findIndexBy: function(array, property, value) {
			return array.findIndex(function(e) { return e[property] === value; });
		},
		sortBy : function(array, property, extraProperty) {
			function compare(a,b) {
				var p;
				if (a[property] < b[property])
					return -1;
				if (a[property] > b[property])
					return 1;

				if(extraProperty !== undefined) {
					for(var x=2;x < arguments.length;x++) {
						p = arguments[x];
						if (a[p] < b[p])
							return -1;
						if (a[p] > b[p])
							return 1;
					}
				}
				return 0;
			}
			array.sort(compare);
			return array;
		},
		removeBy: function(array, property, value) {
			var index = UTILS.array.findIndexBy(array, property, value);
			if (index >= 0)
				array.splice(index, 1);
			return array;
		},

		mapByName: function(array) {
			return UTILS.array.mapBy(array, 'name');
		},
		containsByName: function(array, name) {
			return UTILS.array.containsBy(array, 'name', name);
		},
		findByName: function(array, name) {
			return UTILS.array.findBy(array, 'name', name);
		},
		findByNames: function(array, names) {
			return UTILS.array.findByValues(array, 'name', names);
		},
		findIndexByName: function(array, name) {
			return UTILS.array.findIndexBy(array, 'name', name);
		},
		sortByName : function(array) {
			return UTILS.array.sortBy(array, 'name');
		},
		removeByName: function(array, name) {
			return UTILS.array.removeBy(array, 'name', name);
		},

		mapById: function(array) {
			return UTILS.array.mapBy(array, 'id');
		},
		containsById: function(array, id) {
			return UTILS.array.containsBy(array, 'id', id);
		},
		findById: function(array, id) {
			return UTILS.array.findBy(array, 'id', id);
		},
		findByIds: function(array, ids) {
			return UTILS.array.findByValues(array, 'id', ids);
		},
		findIndexById: function(array, id) {
			return UTILS.array.findIndexBy(array, 'id', id);
		},
		sortById : function(array) {
			return UTILS.array.sortBy(array, 'id');
		},
		removeById: function(array, id) {
			return UTILS.array.removeBy(array, 'id', id);
		},
		equals: function (a1, a2) {
			var res =
				a1.length === a2.length
				&&
				a1.every(function(value, index) {
					return value === a2[index];
				});
			return res;
		},
		// Renvoie les arguments sous forme de tableau, en éclatant les arguments qui sont eux-mêmes des tableaux
		// flatConcat(1, [2, 3, 4], 5, [6, 7]) renverra [1, 2, 3, 4, 5, 6, 7]
		flatConcat: function() {
			if (arguments.length === 0)
				return [];
			if (arguments.length === 1)
				return $.isArray(arguments[0]) ? arguments[0] : [arguments[0]];
			var r = [];
			for (var i = 0; i < arguments.length; i++) {
				if ($.isArray(arguments[i]))
					r = r.concat(arguments[i]);
				else
					r.push(arguments[i]);
			}
			return r;
		},
	},
	datetime : {
		weekdays: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
		formatInternal: function(date) {
			return moment(date).format('YYYY/MM/DD HH:mm:ss');
		},
		parseInternal: function(stringDate) {
			return moment(stringDate, 'YYYY/MM/DD HH:mm:ss').valueOf();
		},
		displayDateTime: function(date) {
			return moment(date).format(SOLVNET.getLang("LocaleDateTimeFormat"));
		},
		displayDate: function(date) {
			return moment(date).format(SOLVNET.getLang("LocaleDateFormat"));
		},
		/**
		 * Complète une liste d'erreurs si il y a une incohérence de début & fin d'une plage de date.
		 * @param start en ms depuis epoch
		 * @param end en ms depuis epoch
		 * @param errors array of errors to complete
		 */
		validateDateRange: function(start, end, errors) {
			if (start == null || end == null || start <= end)
				return;
			var format = SOLVNET.getLang("LocaleDateFormat");
			var error = SOLVNET.getLang("InputDateRangeError", moment(start).format(format), moment(end).format(format));
			errors.push(error);
		},
		/**
		 * Complète une liste d'erreurs si il y a une incohérence de début & fin d'une plage d'heure.
		 * @param start en ms depuis epoch
		 * @param end en ms depuis epoch
		 * @param errors array of errors to complete
		 */
		validateTimeRange: function(start, end, errors) {
			if (start == null || end == null || start <= end)
				return;
			var format = SOLVNET.getLang("LocaleTimeFormat");
			var error = SOLVNET.getLang("InputDateRangeError", moment(start).format(format), moment(end).format(format));
			errors.push(error);
		}
	},
	date: {
		formatInternal: function(date) {
			return moment(date).format('YYYY/MM/DD');
		},
		parseInternal: function(stringDate) {
			return moment(stringDate, 'YYYY/MM/DD').valueOf();
		},
	},
	time: {
		formatInternal: function(date) {
			return moment(date).format('HH:mm:ss');
		},
		parseInternal: function(stringDate) {
			return moment(stringDate, 'HH:mm:ss').valueOf();
		},
	},
	bytes : {
		getFormatedSize: function(sizeInBytes) {
			// 1 073 741 824 = 1024 * 1024 * 1024
			if (sizeInBytes >= 1073741824)
				return Math.floor(sizeInBytes / 1073741824) + SOLVNET.getLang("CommonAttachmentUnitGigaBytes");
			// 1 048 576 = 1024 * 1024
			if (sizeInBytes >= 1048576)
				return Math.floor(sizeInBytes / 1048576) + SOLVNET.getLang("CommonAttachmentUnitMegaBytes");
			if (sizeInBytes >= 1024)
				return Math.floor(sizeInBytes / 1024) + SOLVNET.getLang("CommonAttachmentUnitKiloBytes");
			return Math.floor(sizeInBytes) + SOLVNET.getLang("CommonAttachmentUnitBytes");
		}
	},
	units : {
		volumes: [
			{name: 'l', coefBase: 1000000},
			{name: 'cl', coefBase: 10000},
			{name: 'ml', coefBase: 1000},
			{name: 'mm3', coefBase: 1},
			{name: 'cm3', coefBase: 1000},
			{name: 'm3', coefBase: 1000000000}
		],
		getVolume: function(value) {
			return UTILS.math.divide(value.valueAsMm3, UTILS.units.volumes[value.unitId].coefBase);
		},
		weights: [
			{name: 'mg', coefBase: 1},
			{name: 'cg', coefBase: 10},
			{name: 'dg', coefBase: 100},
			{name: 'g', coefBase: 1000},
			{name: 'kg', coefBase: 1000000}
		],
		getWeight: function(value) {
			return UTILS.math.divide(value.valueAsMg, UTILS.units.weights[value.unitId].coefBase);
		}
	},
	math : {
		mult: function(a, b) {
			return (UTILS.math.isNumber(a) && UTILS.math.isNumber(b)) ? (a * b) : null;
		},
		divide: function(a, b) {
			return (UTILS.math.isNumber(a) && UTILS.math.isNumber(b) && b !== 0) ? (a / b) : null;
		},
		add: function(a, b) {
			return (UTILS.math.isNumber(a) || UTILS.math.isNumber(b)) ? ((a || 0) + (b || 0)) : null;
		},
		sum : function() {
			var s;
			for(var x=0;x < arguments.length;x++) {
				var v = arguments[x];
				if(UTILS.math.isNumber(v)) {
					// Ici, v  est un chiffre.
					if(s) {
						// s supérieur ou égale à 0 , on y a ajoute v.
						s += v;
					} else {
						// s est soit égale à 0, soit undefined ou null => on peut directement affecter v.
						s = v;
					}
				}
			}
			return s;
		},
		cumulPct: function(pct1, pct2, pct3) {
			// 1 - (1 - pct1 / 100) * (1 - pct2 / 100) * (1 - pct3 / 100)
			if (!UTILS.math.isNumber(pct1) && !UTILS.math.isNumber(pct2) && !UTILS.math.isNumber(pct3))
				return null;
			var result = 1.0;
			if (UTILS.math.isNumber(pct1))
				result *= (1 - pct1 / 100);
			if (UTILS.math.isNumber(pct2))
				result *= (1 - pct2 / 100);
			if (UTILS.math.isNumber(pct3))
				result *= (1 - pct3 / 100);
			return 100 - 100 * result;
		},
		isNumber: function(v) {
			return typeof v === 'number' && ! isNaN(v);
		},
		sumMult: function(v1, v2, v3, factor) {
			if ((!UTILS.math.isNumber(v1) && !UTILS.math.isNumber(v2) && !UTILS.math.isNumber(v3))
					|| !UTILS.math.isNumber(factor))
				return null;
			if (factor === 0)
				return factor;
			var result = 0;
			if (v1 != null)
				result += v1;
			if (v2 != null)
				result += v2;
			if (v3 != null)
				result += v3;
			return result * factor;
		},
		netPrice: function(price, units, valDiscount, pctDiscount) {
			// (price - units * valDiscount) * (1 - pctDiscount / 100)
			if (! price)
				return undefined;
			var result = price * 1.0;
			if (valDiscount)
				result -= valDiscount * (units ? units : 1);
			if (pctDiscount)
				result *= (1 - pctDiscount / 100);
			return result;
		},
		netCost: function (qty, dis, userPrice, calcPrice) {
			// (qty - dis) * (userPrice or calcPrice)
			if ((!UTILS.math.isNumber(qty) && !UTILS.math.isNumber(dis))
					|| (!UTILS.math.isNumber(userPrice) && !UTILS.math.isNumber(calcPrice)))
				return null;
			var quantity = (!UTILS.math.isNumber(qty) ? 0 : qty) - (!UTILS.math.isNumber(dis) ? 0 : dis);
			var price = (!UTILS.math.isNumber(userPrice) ? calcPrice : userPrice);
			return quantity * price;
		}
	},
	aggregators: { // Ne pas ajouter d'entrée ici car c'est une énumération correspondant aux IDataAggregator côté Java
		min: {
			aggregate: function(total, value) {
				if (total === null)
					return value;
				if (value === null)
					return total;
				var compare = UTILS.object.compare(total, value);
				return (compare > 0) ? value : total;
			}
		},
		max: {
			aggregate: function(total, value) {
				if (total === null)
					return value;
				if (value === null)
					return total;
				var compare = UTILS.object.compare(total, value);
				return (compare < 0) ? value : total;
			}
		},
		sum: {
			start: function() {return 0;},
			aggregate: function(total, value) {
				if (typeof value === 'boolean')
					return total + (value ? 1 : 0);
				// Conforme 1.6, Ici, l'aggregate considère le Null , comme un 0 (voir SumAggregator)
				return total + (value === null ? 0 : value);
			}
		},
		count: {
			start: function() {return 0;},
			aggregate: function(total, value) {
				return total + (value === null ? 0 : 1);
			}
		},
		avg: {
			start: function() {return [0, 0];},
			aggregate: function(total, value) {
				if (value != null) {
					total[0] += 1; // count
					total[1] += value; // sum
				}
				return total;
			},
			finish: function(total) {
				if (total[0] === 0)
					return null; // vide
				return total[1] / total[0]; // moyenne
			}
		},
		distinctsum: {
			start: function() {return [];}, // empty set
			aggregate: function(total, value) {
				if (value != null)
					UTILS.array.addIfNotFound(total, value);
				return total;
			},
			finish: function(values) {
				var total = 0;
				for (var i = 0; i < values.length; i++) {
					total += values[i];
				}
				return total;
			}
		},
		distinctcount: {
			start: function() {return [];}, // empty set
			aggregate: function(total, value) {
				if (value != null)
					UTILS.array.addIfNotFound(total, value);
				return total;
			},
			finish: function(values) {
				return values.length;
			}
		},
		distinctavg: {
			start: function() {return [];}, // empty set
			aggregate: function(total, value) {
				if (value != null)
					UTILS.array.addIfNotFound(total, value);
				return total;
			},
			finish: function(values) {
				var total = 0;
				for (var i = 0; i < values.length; i++) {
					total += values[i];
				}
				return values.length === 0 ? null : (total / values.length);
			}
		},
		repeated: {
			start: function() {return false;}, // nothing yet
			aggregate: function(total, value) {
				if (!total)
					return [value]; // first result
				var compare = UTILS.object.compare(total[0], value);
				if (compare !== 0)
					total[0] = null; // return null if 2 different values are found
				return total;
			},
			finish: function(total) {
				if(total === false) {
					return null;
				}
				return total[0];
			}
		},
		rowcount: {
			start: function() {return 0;},
			aggregate: function(total, value) {
				return total + 1;
			}
		},
	},
	files : {
		isImageFile: function(name) {
			var nameUC = name.toUpperCase();
			return nameUC.endsWith(".JPG") || nameUC.endsWith(".JPEG") || nameUC.endsWith(".PNG") || nameUC.endsWith(".GIF");
		},
		getSmallFileIcon: function (text) {
			var filename = text.toUpperCase();

			var image;
			if(filename.endsWith(".XLS") || filename.endsWith(".XLSX") || filename.endsWith(".XLSM") || filename.endsWith(".ODS")) {
				image = SOLVNET.getURL('images/files/xls.png');
			} else if(filename.endsWith(".DOC") || filename.endsWith(".DOCX") || filename.endsWith(".DOCM") || filename.endsWith(".ODT")) {
				image = SOLVNET.getURL('images/files/doc.png');
			} else if(filename.endsWith(".PPT") || filename.endsWith(".ODP") || filename.endsWith(".PPS") || filename.endsWith(".PPTX") || filename.endsWith(".PPTM") || filename.endsWith(".PPSX")) {
				image = SOLVNET.getURL('images/files/ppt.png');
			} else if(filename.endsWith(".PDF")) {
				image = SOLVNET.getURL('images/files/pdf.png');
			} else if (filename.endsWith(".MP4") || filename.endsWith(".WMV") || filename.endsWith(".MPG") || filename.endsWith(".MPEG") || filename.endsWith(".MPEG4") || filename.endsWith(".MOV") || filename.endsWith(".AVI") || filename.endsWith(".3GP") || filename.endsWith(".MKV") || filename.endsWith(".FLV") || filename.endsWith(".WEBM")) {
				image = SOLVNET.getURL('images/files/video.png');
			} else {
				image = SOLVNET.getURL('images/files/document.png');
			}

			return $('<img />').attr('src', image).css('width', '16px');
		},
		dataURItoBlob: function(dataURL) {
			var BASE64_MARKER = ';base64,';
			var parts, contentType, raw;

			if (dataURL.indexOf(BASE64_MARKER) === -1) {
				parts = dataURL.split(',');
				contentType = parts[0].split(':')[1];
				raw = decodeURIComponent(parts[1]);
				return new Blob([ raw ], {
					type : contentType
				});
			}

			parts = dataURL.split(BASE64_MARKER);
			contentType = parts[0].split(':')[1];
			raw = window.atob(parts[1]);
			var rawLength = raw.length;
			var uInt8Array = new Uint8Array(rawLength);
			for (var i = 0; i < rawLength; ++i) {
				uInt8Array[i] = raw.charCodeAt(i);
			}
			return new Blob([ uInt8Array ], {
				type : contentType
			});
		}
	},
	users: {
		displayName: function(user) {
			if (!user.firstName && !user.lastName)
				return '';
			return [user.firstName, user.lastName].join(' ');
		}
	},
	attachments: {
		previewOptions: [
			{ value: 'small', title: '32x32', miniatureSize: 32, gridClass: '' },
			{ value: 'medium', title: '64x64', miniatureSize: 64, gridClass: 'preview-medium' },
			{ value: 'large', title: '128x128', miniatureSize: 128, gridClass: 'preview-large' }
		],
		adjustImageFieldForPreview: function(fields, preview) {
			// Ajuster la taille des miniatures à la taille demandée via l'option "preview"
			var imageField = UTILS.array.findByName(fields, 'attachments.image');
			imageField.imagepath = function(row) {
				// On génère des miniature de la taille de "preview" demandée (32, 64 ou 128)
				// Pour cela, on précise "maxHeight" pour ajuster à la hauteur de la ligne
				// Par contre, pas de "maxWidth" pour assurer les 64px en hauteur, quel que soit la largeur (on peut élargir la colonne)
				return 'commonattachment/preview/' + row.id + '?maxHeight=' + preview.miniatureSize + '&time=' + (row.updateDate || row.createDate);
			};
		},
		adjustTextColumnsForPreview: function(columns, preview) {
			// Autoriser le retour du texte à la ligne si on utilise des miniatures en 64x64 ou 128x128
			if (preview.miniatureSize >= 64) {
				var wrapColumnNames = ['attachments.description', 'attachments.filename'];
				columns.forEach(function(column) {
					if (wrapColumnNames.indexOf(column.name) >= 0) {
						column.overrideContent(function(content, row) {
							// On encapsule le contenu dans une classe "wrappable" (cf main.css)
							return '<div class="wrappable">' + content + '</div>';
						});
					}
				});
			}
		},
		matchSearch: function(attachment, searchTextToLowerCase, optionalSearchFields) {
			// Texte recherché vide = pas de filtre = acceptée
			if (searchTextToLowerCase === '')
				return true;
			// Sinon = vérifier si la PJ correspond à la recherche
			// - pour le moment, recherche sur "description" et "fileName"
			// - à voir si on cherche sur les infos sup ou sur customerName, tradenameCaption, ...
			var t = attachment.description + attachment.fileName;
			if (optionalSearchFields && optionalSearchFields.length > 0)
				t += optionalSearchFields.join(' + ');
			return t.toLowerCase().indexOf(searchTextToLowerCase) >= 0;
		},
		listenForContextLayoutItemType: function(item) {
			// On déclenche l'écoute sur la propriété indiquée par le modèle, à condition qu'il soit défini
			var attachmentModel, attachmentModelId = item.properties['modelId'];
			if (attachmentModelId) {
				attachmentModel = UTILS.array.findById(attachmentsModels(false), parseInt(attachmentModelId));
				if (attachmentModel)
					return [attachmentModel.contextPropertyListener];
			}
			return [];
		},
		isUsefullForContextLayoutItemType: function(section, contextProperties) {
			// On ne propose cet élément que si le contexte est défini sur l'une des propriétés écoutées par les modèles de PJ
			var models = attachmentsModels(false);
			for (var i = 0; i < models.length; i++) {
				var property = models[i].contextPropertyListener;
				if (property && contextProperties.indexOf(property) !== -1)
					return true;
			}
			return false;
		},
		propertiesForContextLayoutItemType: function() {
			return [
				{ name: 'modelId', type: 'select', description: SOLVNET.getLang('LayoutParamAttachmentModel'), required: true,
					options: attachmentsModels(true)
						.filter(function(c) { return !!c.contextPropertyListener; })
						.map(function(c) { return {value:c.id,title:c.caption}; }),
					addClass: 'attachmentModel'
				},
				{ name: 'options', type: 'attachmentModelOptions', description: SOLVNET.getLang('LayoutParamAttachmentModelOptions') }
			];
		},
		controlsForContextLayoutItemType: function() {
			return [
				LayoutAPI.createSimpleAddControl(SOLVNET.getLang('LayoutItemAttachmentAdd'), 2),
				LayoutAPI.createSimpleSearchControl(SOLVNET.getLang('LayoutItemAttachmentSearch'), 3),
				LayoutAPI.createSimpleEditControl(SOLVNET.getLang('LayoutItemAttachmentOpen'), 1),
				LayoutAPI.createSimpleDeleteControl(SOLVNET.getLang('LayoutItemAttachmentDelete'), 4),
			];
		},
		getPropertyFilterFormula: function() {
			return {name: 'filter', type: 'formula', description: SOLVNET.getLang('LayoutParamAttachmentFilter'), required: false, placeholder: SOLVNET.getLang('LayoutParamAttachmentFilterPlaceholder'), maxlength: 255, url: 'commonattachment/formula'};
		},
		getPropertyEditableByTheseProfiles: function() {
			return {name: 'editableBy', type: 'multiselect', description: SOLVNET.getLang('LayoutParamAttachmentEditableBy'), required: false, maxlength: 255, url: 'admin/profiles/lookup'};
		},
		getEditable: function(optionalProfileIdsAsString) {
			return optionalProfileIdsAsString ? SOLVNET.profileId === null || (optionalProfileIdsAsString.split(",").indexOf('' + SOLVNET.profileId) >= 0) : true;
		},
		checkPropertiesFilterAttachment: function(item) {
			return UTILS.formula.checkProperties(item, 'commonattachment/formula', 'filter');
		},
		createBookContentProperties: function() {
			return [
				{name: 'itemCount', type: 'integer', description: SOLVNET.getLang('LayoutParamAttachmentBookItemCount'), required: false, min: 1, placeholder: SOLVNET.getLang('LayoutParamAttachmentBookItemCountPlaceholder')},
				{name: 'direction', type: 'select', description: SOLVNET.getLang('LayoutParamAttachmentBookDirection'), required: true, defaultValue: 'row', options: [
					{value: 'row', title: SOLVNET.getLang('LayoutParamAttachmentBookDirectionRow')},
					{value: 'column', title: SOLVNET.getLang('LayoutParamAttachmentBookDirectionColumn')},
				]},
				{name: 'slideshowInterval', type: 'integer', description: SOLVNET.getLang('LayoutParamAttachmentBookSlideshowInterval'), required: false, min: 0, placeholder: SOLVNET.getLang('LayoutParamAttachmentBookSlideshowIntervalPlaceholder')},
				{name: 'showDescription', type: 'checkbox', description: SOLVNET.getLang('LayoutParamAttachmentBookShowDescription'), defaultValue: true },
			];
		},
		createBookContent: function() {
			return $(''
				+ '<div style="width: 100%; height: 100%; ">'
				+ '  <div style="width: 100%; height: 40px; padding: 0 20px; display: none; ">'
				+ '    <input type="search" class="form-control" placeholder="' + SOLVNET.getLang('LayoutItemAttachmentSearchPlaceholder') + '" />'
				+ '  </div>'
				+ '  <div style="display: flex; align-items: center; width: 100%; height: calc(100% - 30px);">'
				+ '    <i class="bbm-rotate material-icons bbm-wait" style="font-size: 16pt; display: none; margin: auto; ">refresh</i>'
				+ '    <img style="flex: none; margin: auto; max-width: 100%; max-height: 100%; touch-action: manipulation; " src="' + SOLVNET.getURL('images/empty.png') + '" />'
				+ '  </div>'
				+ '  <div style="width: 100%; height: 30px; display: flex; flex-direction: row; ">'
				+ '    <span style="flex: 1 1 auto; align-self: center; max-height: 32px; line-height: 1; font-size: 10pt; padding-top: 2px; " class="description">Description</span>'
				+ '    <span style="flex: 0 0 auto;" class="position">1 / 1</span>'
				+ '    <button style="flex: 0 0 auto; height: 28px; padding: 2px 10px; " type="button" class="btn btn-link prev"><i class="material-icons nav-prev"></i></button>'
				+ '    <button style="flex: 0 0 auto; height: 28px; padding: 2px 10px; " type="button" class="btn btn-link next"><i class="material-icons nav-next"></i></button>'
				+ '  </div>'
				+ '</div>');
		}
	},
	visits: {
		checkAfterStatementControl: function(controlContext) {
			if (controlContext.modifications.includes(controlContext.visit))
				$(controlContext.visit).trigger('solvnet.modelchange');
		},
		checkAfterStatementListChanged: function(context, changes, doneCallback) {
			// Récupérer le client
			var deferredCustomer;
			if (context.customer)
				deferredCustomer = $.Deferred().resolve(context.customer);
			else
				deferredCustomer = SOLVNET.getPromiseCustomer(context.customerId, context.marketId, false);

			// Puis ...
			deferredCustomer.then(function(customer) {
				// Récupérer la visite
				var deferredVisit;
				if (context.visit)
					deferredVisit = $.Deferred().resolve(context.visit);
				else
					deferredVisit = SOLVNET.getPromiseVisit(context.visitId, customer, false);

				// Puis récupérer l'eventTypeId si besoin
				deferredVisit.then(function(visit) {
					if (!visit.eventTypeId) {
						return $.get(SOLVNET.getURL('planner/getEventTypeId', {eventId: visit.plannerEventId})).then(function(eventTypeId) {
							visit.eventTypeId = eventTypeId;
							return visit;
						});
					}
					return visit;
				// Puis ...
				}).then(function(visit) {
					// Ajuster les infos calculées en fonction de l'endroit où la fonction est appelée
					for (var p in changes) {
						if (typeof changes[p] === 'boolean')
							visit.calculatedInformations[p] = changes[p];
						else
							visit.calculatedInformations[p] += changes[p];
					}
					// Exécuter les contrôles indiquant que la visite est modifiée
					var c = ControlAPI.createVisitContext(customer, visit);
					ControlAPI.execute(ControlAPI.types.Visit, ControlAPI.actions.ModifyHeader, c, function(result) {
						// console.log(visit.id, SOLVNET.visit.id, visit === SOLVNET.visit, c.modifications.includes(visit));
						if (c.modifications.includes(visit))
							$(visit).trigger('solvnet.modelchange');
						doneCallback();
					});
				});
			});
		}
	},
	offers: {
		checkAfterStatementControlOfferScopeChanged: function(controlContext) {
			// L'univers a été cloné, on cherche dans modifications si on trouve une modifications.
			if (controlContext.modifications.includes(controlContext.customerScope)) {
				// Oui, on réinjecte dans l'objet métier l'univers modifié
				controlContext.offerHeader.customerScope.updateAfterControls(controlContext.customerScope);
			}
		},
		getGanttOfferGroups: function(callback) {
			var options = [
				{id: '0', caption: SOLVNET.getLang('LayoutParamPlanningOfferGanttChartGroupCircuit')},
				{id: '1', caption: SOLVNET.getLang('LayoutParamPlanningOfferGanttChartGroupPurchaseGroup')},
				{id: '2', caption: SOLVNET.getLang('LayoutParamPlanningOfferGanttChartGroupTradename')},
				{id: '3', caption: SOLVNET.getLang('LayoutParamPlanningOfferGanttChartGroupAll')},
				{id: '4', caption: SOLVNET.getLang('LayoutParamPlanningOfferGanttChartGroupTrademark')},
				{id: '6', caption: SOLVNET.getLang('LayoutParamPlanningOfferGanttChartGroupCustomerGroup')},
				{id: '7', caption: SOLVNET.getLang('LayoutParamPlanningOfferGanttChartGroupProductGroup')}
			];
			if (callback)
				callback(options);
			return options;
		},
		destroyPopoverEventActive: false,
		generateGanttChartPopover: function(target, itemProperties, itemDiv, context, offers, lastSelectedOffer) {
			if (!this.destroyPopoverEventActive) {
				this.destroyPopoverEventActive = true;
				$(document.body).on('mousedown', function(e) {
					// Supprimer le popover sauf si on clique dans un popover
					if ($(e.target).closest('.gantPopover').length === 0)
						$('.gantPopover').popover('destroy');
				});
			}
			var minLeftDisplayed;
			var maxLeftDisplayed;
			var minTopDisplayed;
			var maxTopDisplayed;
			target.popover({selector: '.shape', trigger: 'click', html: true,
				placement: function (context, source) {
					minLeftDisplayed = $(source).parent().parent().scrollLeft();
					maxLeftDisplayed = minLeftDisplayed + $(source).parent().parent().width();
					minTopDisplayed = $(source).closest('.box-overflow').scrollTop();
					maxTopDisplayed = minTopDisplayed + $(source).closest('.box-overflow').height() - $(source).closest('.ganttchart').find('.top').height();
					return ($(source).position().top < 100) ? 'bottom' : 'top';
				},
				content: function() {
					// on crée le contenu du popover
					var formatDate = SOLVNET.getLang('LocaleDateFormat'),
						offer = UTILS.array.findById(offers, $(this).data('item').offerId),
						$table = $(''
							+ '<table style="max-width: 500px; width: auto; white-space: nowrap; font-size: 13px">'
							+ '  <tr>'
							+ '    <td colspan="2">'
							+ '      <span style="font-weight: bold; font-size: 12pt; text-transform: uppercase;">'
							+               offer.caption
							+               (offer.trademark ? ' (' + offer.trademark + ')' : '')
							+               (offer.segmentation ? ' (' + offer.segmentation + ')' : '')
							+ '      </span>'
							+ '    </td>'
							+ '  </tr>'
							+ '</table>'
						),
						periodFormatedText = function(start, end) {
							if (start && end) {
								return SOLVNET.getLang('PlanningOfferGanttChartFromToDateLabel', moment(start).format(formatDate), moment(end).format(formatDate));
							} else if (start) {
								return SOLVNET.getLang('PlanningOfferGanttChartFromDateLabel', moment(start).format(formatDate));
							} else if (end) {
								return SOLVNET.getLang('PlanningOfferGanttChartUntilDateLabel', moment(end).format(formatDate));
							} // si aucune date de début ou fin de renseignée, on n'affiche rien car la promo est sur toute la période
							return '<i>' + SOLVNET.getLang('PlanningOfferGanttChartEmptyRangeDateLabel') + '</i>';
						},
						newTableRow = function(title, htmlText, color) {
							var spanColor = (color !== undefined)
								? '<span style="width: 25px; height: 7px; background-color: ' + color + '; display: inline-table; margin: 1px 5px 1px 1px; border: 1px solid #efefef; ">&nbsp</span>'
								: '';
							return $(''
								+ '<tr>'
								+ '  <td style="vertical-align: top;">'
								+ '    <li>'
								+ '      <span style="float: right;">&nbsp : &nbsp</span>' // mis en première position pour être fixe à droite sur la même ligne.
								+        spanColor
								+ '      <span style="font-weight: bold;">' + title + '</span>'
								+ '    </li>'
								+ '  </td>'
								+ '  <td style="white-space: normal;">'
								+      htmlText
								+ '  </td>'
								+ '</tr>'
							);
						},
						generatePopover = function(offer, offerDatas) {
							if (offer.comments) {
								var commentsTextarea = $('<pre style="background-color: #6a6a6a; color: #efefef; white-space: normal; margin: 0; padding: 0; border-width: 0; font-family: inherit; font-size: inherit; " >');
								commentsTextarea.text(offer.comments);
								$table.append(newTableRow(SOLVNET.getLang('OfferHeaderComments'), commentsTextarea[0].outerHTML));
							}
							if (offerDatas.tradenames && offerDatas.tradenames.length > 0) {
								$table.append(newTableRow(offerDatas.captions['Tradename'] || SOLVNET.getLang('PlanningOfferGanttChartTradenamesLabel'), offerDatas.tradenames.join(', ')));
							}
							if (offerDatas.purchaseGroups && offerDatas.purchaseGroups.length > 0) {
								$table.append(newTableRow(offerDatas.captions['PurchaseGroup'] || SOLVNET.getLang('PlanningOfferGanttChartPurchaseGroupsLabel'), offerDatas.purchaseGroups.join(', ')));
							}
							if (offerDatas.trademarks && offerDatas.trademarks.length > 0) {
								$table.append(newTableRow(offerDatas.captions['Trademark'] || SOLVNET.getLang('PlanningOfferGanttChartTrademarkLabel'), offerDatas.trademarks.join(', ')));
							}
							if (offerDatas.segmentations && offerDatas.segmentations.length > 0) {
								$table.append(newTableRow(offerDatas.captions['Segmentation'] || SOLVNET.getLang('PlanningOfferGanttChartSegmentationLabel'), offerDatas.segmentations.join(', ')));
							}
							if (itemProperties['range'].indexOf('visit') > -1) {
								var offerRangeVisitDateCaption = itemProperties['visitShapeCaption'] || SOLVNET.getLang('OfferRangeVisitDate');
								$table.append(newTableRow(offerRangeVisitDateCaption, periodFormatedText(offer.visitStartDate, offer.visitEndDate), itemProperties['visitShapeColor']));
							}
							if (itemProperties['range'].indexOf('delivery') > -1) {
								var offerRangeDeliveryDateCaption = itemProperties['deliveryShapeCaption'] || SOLVNET.getLang('OfferRangeDeliveryDate');
								$table.append(newTableRow(offerRangeDeliveryDateCaption, periodFormatedText(offer.deliveryStartDate, offer.deliveryEndDate), itemProperties['deliveryShapeColor']));
							}
							if (itemProperties['range'].indexOf('operation') > -1) {
								var offerRangeOperationDateCaption = itemProperties['operationShapeCaption'] || SOLVNET.getLang('OfferRangeOperationDate');
								$table.append(newTableRow(offerRangeOperationDateCaption, periodFormatedText(offer.operationStartDate, offer.operationEndDate), itemProperties['operationShapeColor']));
							}

							// on applique sur les textarea le rendu voulu
							$table.find('textarea').css('font-size', $table.css('font-size')).autoExpandTextarea();
						};

					if (!lastSelectedOffer || (lastSelectedOffer.offerId !== offer.id)) {
						$.get(
							SOLVNET.getURL('planningoffer/getOfferInformations'), { offerId: offer.id, marketId: context.marketId }
						).done(function(offerDatas) {
							SOLVNET.getPromiseOffer(offer.id, context.marketId, true)
							.then(function(resultOffer) {
								// on génère le popover
								generatePopover(offer, offerDatas);
								// on sauvegarde les données de la promo
								itemDiv.data('selectedOffer', {offerId: offer.id, infos: offerDatas});
								// on change la promotion dans le contexte
								context.updateContextAndTriggerContextChangeEvent({offerId: offer.id, offerHeader: resultOffer.offerHeader, offerDetails: resultOffer.details});
								// on rend accessible le bouton d'édition
								LayoutAPI.toggleControl(itemDiv, 'edit', true);
							});
						}).fail(function error(error) {
							SOLVNET.showError(SOLVNET.getLang("PlanningOfferGanttChartOfferFailedToLoad"));
						});
					} else {
						generatePopover(offer, lastSelectedOffer.infos);
					}

					return $table;
				}
			})
			.on('inserted.bs.popover', function() {
				// Cacher le popover avant qu'il apparaisse car la position n'est pas bonne.
				// En effet, les "area" ne semblent pas retourner les positions correctes
				$('.popover').css('visibility', 'hidden');
				$('.popover').children('.arrow').hide();
			})
			.on('shown.bs.popover', function() {
				// on applique le style que l'on veut au popover
				var popoverElement = $('.popover');
				popoverElement.css('max-width', (maxLeftDisplayed - minLeftDisplayed - 20) + 'px') // marge de 10px de chaque côté
					.css('background-color', '#6a6a6a') // la couleur de fond
					.css('color', '#efefef') // la couleur de la font
					.addClass('gantPopover');

				if (popoverElement.position().left < minLeftDisplayed) {
					popoverElement.css('left', (minLeftDisplayed + 10) + 'px'); //marge de 10px
				}
				else if (popoverElement.position().left + popoverElement.width() > maxLeftDisplayed) {
					popoverElement.css('left', (maxLeftDisplayed - popoverElement.width() - 10) + 'px'); //marge de 10px
				}
				if (popoverElement.position().top < minTopDisplayed) {
					popoverElement.css('top', (minTopDisplayed + 10) + 'px'); //marge de 10px
				}
				else if (popoverElement.position().top + popoverElement.height() > maxTopDisplayed) {
					popoverElement.css('top', (maxTopDisplayed - popoverElement.height() - 10) + 'px'); //marge de 10px
				}
				popoverElement.css('visibility', 'visible');
			});
		},
		generateGanttChartLeft : function(container, item, runtime, groups, caption) {
			if (runtime) {
				var table = container.find('table');

				if (table.length === 0)
					table = $('<table />').appendTo(container);
				var row = $('<tr />');

				/*ajouter dans content ce que l'on veut mettre dedans en runtime
					en fonction du groupe de la configuration on pourra afficher l'enseigne, la marque, la centrale ou autre de la promotion
					et le libelle de la promo
				*/
				if (item.groupId && groups.length > 0) {
					var group = UTILS.array.findById(groups, item.groupId);
					var groupCol = $('<td />').appendTo(row);
					// est ce que l'on veut une image : folderType est renseigné // uniquement marque et enseigne
					if (item.useImg) {
						groupCol.css('text-align', 'center');
						var url = group
							? group.img
									? SOLVNET.getURL('attachment/stream', { name: group.img, folderType: group.folderType })
									: ''
							: SOLVNET.getURL('images/default-image.png');
						if (url) {
						$('<img class="group-img"/>')
							.attr('src', url)
							.css('height', '30px')
							.css('width', '30px')
							.css('margin', 'auto')
							.css('padding', '2px')
							.css('object-fit', 'scale-down')
							.appendTo(groupCol);
						}
					} else { // on a affaire a une hiérachie. circuit ou centrale, on affiche un text
						$('<span />')
							.text(group ? group.caption : SOLVNET.getLang('PlanningOfferGanttChartUnspecifiedLabel'))
							.css('margin-right', '10px')
							.css('margin-left', '10px')
							.css('white-space', 'nowrap')
							.appendTo(groupCol);
					}
				}
				var height = (row.find('img') ? 30 : 20) + 'px';
				var col = $('<td />').appendTo(row);
				$('<span />')
					.text(caption)
					.css('height', height)
					.css('width', 'auto')
					.css('margin-right', '10px')
					.css('white-space', 'nowrap')
					.appendTo(col);

				row.css('height', height).appendTo(table);
			} else {
				$('<div />')
					.text(SOLVNET.getLang('PlanningOfferGanttChartParamGroupLabel'))
					.css('min-height', '25px')
					.css('display', 'inline-block')
					.appendTo(container);
			}
		},
		generateGanttChartInputGroupFilter : function(ganttChartDiv, groups, options, leftWidth, localStorageKey) {
			// on affiche la zone de filtre sur les groupe si il y a besoin (c'est une zone de recherche par autocomplétion)
			var groupsUseInItems = groups.filter(function(group) { // Pour ne proposer que les groupes utilisés dans les items
				return UTILS.array.findIndexBy(options.items, "groupId", group.id) >= 0;
			});
			var filterGroups = function(item, groupId) {
					return item.groupId === groupId
						|| item.groupId === -1; // si on veut voir aussi les promotions qui ne sont pas rattachées a un groupe
				};
			var saveState = JSON.parse(localStorage.getItem(localStorageKey));
			if (groups.length > 0 && groupsUseInItems.length > 0) {
				// Pour recharger les données du ganttChart lorsque l'on applique un filtre par groupe
				var reloadGanttChart = function(elements) {
					ganttChartDiv.ganttChart().setItems(elements);
					// on redessine la partie centrale et la partie gauche
					ganttChartDiv.ganttChart().refreshLeft();
					ganttChartDiv.ganttChart().refreshCenter();
				};

				var input = $('<input type="text" style="margin: 5px 5px; height: 24px; position:absolute; left:0px; top:0px;" />')
						.css('width', (leftWidth - 10) + 'px') //10 pour les marges gauche et droite
						.attr('placeholder', SOLVNET.getLang('PlanningOfferGanttChartFilterByGroupLabel'))
						.appendTo(ganttChartDiv.find('.ganttchart'));

				input.devbridgeAutocomplete({
					minChars: 1, // rechercher à partir d'un caractère
					width: 'auto', // de la taille de l'input
					showNoSuggestionNotice: true,  // si pas de resultat pour la recherche informer l'utilisateur
					noSuggestionNotice: SOLVNET.getLang('NoResultSearch'),
					lookup: groupsUseInItems.map(function(group) { return {value: group.caption, groupId: group.id}; }),
					onSelect: function(suggestion) {
						var groupId = suggestion.groupId;
						// on filtre les items
						reloadGanttChart(options.items.filter(function(item) { return filterGroups(item, groupId); }));
						if (saveState.groupFilter !== groupId) {
							saveState.groupFilter = groupId;
							localStorage.setItem(localStorageKey, JSON.stringify(saveState));
						}
					}
				}).on('focus', UTILS.functions.autoselectonfocus
				).on('change', function(event) {
					if (!$(event.target).val()) {
						reloadGanttChart(options.items);
						saveState.groupFilter = '';
						localStorage.setItem(localStorageKey, JSON.stringify(saveState));
					}
				});

				if (saveState.groupFilter) {
					var group = UTILS.array.findById(groupsUseInItems, parseInt(saveState.groupFilter));
					if (group) {
						input.val(group.caption);
						reloadGanttChart(options.items.filter(function(item) { return filterGroups(item, parseInt(saveState.groupFilter)); }));
					}
				}
			}
		}
	},
	tree : {
		/**
		 * Cette fonction calcule le chemin de 'caption' pour le noeud TreeNode (max 50 caractères )
		 * A +-B
		 *   |-C
		 *
		 * Pour B => A/B
		 * Pour C => A/C
		 *@param mapOfAllTreeNodeById Map des noeuds par id.
		 *@param treeNode Node dont on souhaite calculer le chemin
		 *@return un chemin de caption de node. (max 50 caractères )
		 */
		captionPath: function(mapOfAllTreeNodeById, treeNode) {
			var node = treeNode;
			if (!node)
				return "erreur";
			var s = node.caption;
			while (!!(node = mapOfAllTreeNodeById[node.parentId])) {
				s = node.caption + " / " + s;
			}

			if (s.length > 50) {
				s = s.substring(0, 22) + "..." + s.substring(s.length - 23, s.length);
			}

			return s;
		},
		listCaptionPaths: function(mapOfAllTreeNodeById, nodes) {
			var captions = [];
			nodes.forEach(function(treeNode) {
				captions.push({
					id:treeNode.id,
					caption: UTILS.tree.captionPath(mapOfAllTreeNodeById, treeNode)
				});
			});
			return captions;
		},
		/**
		 * @param options un tableau de node : [... {id: , parentId:, ...  }
		 * @return [ {id: , parentId: , children: [{...}, ...] , ... }, ...]
		 */
		buildTreeFromList: function(options) {
			var roots = [];
			var nodeByParentId = {};

			options.forEach(function(option) {
				if(! option.parentId) {
					roots.push(option);
				} else {
					var children = nodeByParentId[option.parentId];
					if(! children) {
						children = [];
						nodeByParentId[option.parentId] = children;
					}
					children.push(option);
				}
			});


			options.forEach(function(option) {
				option.children = nodeByParentId[option.id];
			});

			return roots;
		},
		/**
		 * Cette fonction tri un arbre sur la base de sa parenté.
		 * Il garde l'ordre initial. C'est à dire que si vous souhaitez aussi l'ordre alphabétique, il faut que vous triez via l'ordre alphabétique
		 * avant d'appeler cette méthode.
		 * @param srcValues Tableau des noeuds sources
		 * @param dstValue Table des noeuds de destinations
		 * @param optionalParentId est utilisé pour la récursivité. Il est optionel pour l'appel initial
		 * sauf si vous souhaitez garder qu'une sous-branche de l'arbre.
		 * @return Tableaux des noeuds de destination
		 */
		orderHierarchyList: function (srcValues, dstValues, optionalParentId) {
			var count = srcValues.length;
			for (var index = 0; index < count; index++) {
				var value = srcValues[index];
				if ((!optionalParentId && value.depth === 1) || optionalParentId === value.parentId) {
					dstValues.push(value);
					UTILS.tree.orderHierarchyList(srcValues, dstValues, value.id);
				}
			}
			return dstValues;
		}
	},
	fields: {
		PREVIOUS_SUFFIX:"_nm1",
		getOptionsCaptionsFromIds: function (field, options, idsArray) {
			var captions = '';
			var arrayOfCaptions = [];

			if (options && options.length > 0
					&& idsArray && idsArray.length > 0) {
				idsArray.forEach(function(id) {
					var option = UTILS.array.findBy(options, field.valueProperty || 'value', parseInt(id));
					if (option)
						arrayOfCaptions.push(option[field.titleProperty || 'title']);
				});
				captions = arrayOfCaptions.join(', ');
			}

			return captions;
		},
		applyPreviousCaption: function (fields, fieldsRights) {
			if(! fieldsRights)
				return; // Probablement en paramétrage, il n'y aura pas de libellé à corriger.

			return fields.forEach(function(field) {
				var name = field.name;
				if(name.endsWith(UTILS.fields.PREVIOUS_SUFFIX)) {
					name = name.substr(0,name.length - UTILS.fields.PREVIOUS_SUFFIX.length);
					var right =  UTILS.array.findBy(fieldsRights, 'name', name);
					if(right && right.caption) {
						field.caption =right.caption + SOLVNET.getLang('LinearPreviousSuffix');
					}
				}
			});
		},
		createPreviousFieldsFrom: function (fields) {
			return fields.map(function(field) {
				var previousField = $.extend(true, {}, field);
				previousField.name += UTILS.fields.PREVIOUS_SUFFIX;
				previousField.caption += SOLVNET.getLang('LinearPreviousSuffix');
				previousField.noMarketAccess = true;
				previousField.readonly = true;
				previousField.nullable = true;
				if(previousField.subObjectProperty) {
					previousField.subObjectProperty = "previous." + previousField.subObjectProperty;
				} else {
					previousField.subObjectProperty = "previous";
				}
				return previousField;
			});
		},
		getFieldReadonly: function (wrapper, type, value) {
			// Types: checkbox, input, textarea
			switch (type) {
				case 'text':
					wrapper.append($('<span/>').text(value));
					break;
				case 'checkbox':
					wrapper.append($(value ? '<i>check_box</i>' : '<i style="color: rgba(0, 0, 0, .54);">check_box_outline_blank</i>')
						.addClass('material-icons')
						.css('display', 'block'));
					break;
				case 'textarea':
					wrapper.append($('<p/>').text(value));
					break;
				default:
			}
		},
		getFieldNullable: function(field) {
			// Utiliser l'info précisée par les champs eux-mêmes si possible
			if (typeof field.nullable !== 'undefined')
				return field.nullable;
			// Pour les champs booléen, on considère qu'ils ne peuvent pas être vide (true ou false)
			if (field.type === 'boolean' || field.type === 'checkboxAMPM')
				return false;
			// Les champs "id", "create_date" et "create_user_id" sont forcément alimentés
			if (field.property === 'id' || field.property === 'createDate' || field.property === 'createUserId')
				return false;
			// Sinon, par défaut, on considère que ça peut être vide car c'est la grande majorité des champs
			return true;
		},
		getFieldAccessRules: function() {
			return {
				Invisible : { access: 0, visible: false, readonly: true , modifiable: false, required: false },
				Fixed     : { access: 1, visible: true , readonly: true , modifiable: false, required: false },
				ReadOnly  : { access: 2, visible: true , readonly: true , modifiable: false, required: false },
				Modifiable: { access: 4, visible: true , readonly: false, modifiable: true , required: false },
				Required  : { access: 5, visible: true , readonly: false, modifiable: true , required: true  }
			};
		},
		injectAccessRule: function(field, accessRule) {
			// Si les access du field sont un tableau
			if (accessRule && field.rights) {
				// On applique à tous les éléments, les nouveaux droits
				if (field.access) {
					field.access = field.access.map(function(a){ return accessRule; });
				} else {
					// Ou on crée le tableau et un objet correspondant au champ
					field.access = [accessRule];
				}
			} else {
				field.access = accessRule;
			}
		},
		replaceAccessByCustomizations: function(field, customizations, accessRules) {
			// Le but est de personnaliser les droits d'accès à un champ suite à un contrôle.
			// Il faut par contre faire à attention pour conserver les libellés et autres infos.
			// - cf bug chez RFD CP : https://support.solvnet.fr:9998/devels/edit/2855
			// - cf bug chez Actiale : https://support.solvnet.fr:9998/devels/edit/2781
			// - cf bug chez Eckes : https://support.solvnet.fr:9998/devels/edit/2951
			function customize(name, access) {
				var c = customizations[name];
				if (c && c.access) {
					// accessRules provient de UTILS.fields.getFieldAccessRules
					$.extend(access, accessRules[c.access]);
				}
			}

			if (Array.isArray(field.rights)) {
				// Pour les champs hiérarchiques (centrale, circuit, ...), field.access est un tableau
				// - contenant une entrée pour le champ complet (customers.circuit par exemple)
				// - contenant aussi une entrée pour chaque niveau (customers.circuit_1_id, customers.circuit_2_id par exemple)
				// Le but est d'injecter les droits personnalisés de chaque entrée du tableau
				var originAccess = field.access || [];
				field.access = field.rights.map(function(rightName, idx) {
						// Droit d'origine.
					var access = UTILS.array.findByName(originAccess, rightName);
					// Non trouvé = Invisible
					if (! access)
						access = $.extend({name: rightName}, accessRules['Invisible']);
					// Droit customisé.
					customize(rightName, access);
					return access;
				});
			} else {
				// Pour les champs "simples" (enseigne, surface, ...), field.access est un objet
				// Le but est d'injecter les droits personnalisés du champ (customers.tradename_id par exemple)
				customize(field.name, field.access);
			}
		}
	},
	form: {
		selectToIds: function(select) {
			var result = $(select).val();
			if (!result)
				return undefined;
			return result.map(function(idString) {
				return parseInt(idString);
			});
		},
		/**
		 * Serialization d'un objet dans un formulaire FormData (le code est probablement spécifique pour Webmotion).
		 * Attention, si vous réutilisez cette fonction, elle ne gère les tableaux d'objets : exemple {data:[{id:1, name:'toto'}, {id:2, name:'tata'}]}
		 */
		appendFormData: function (formData, name, values){
			var key;
			if (! values) {
				formData.append(name, '');
			} else if (Array.isArray(values)) {
				values.forEach(function(data) {
					formData.append(name, data);
				});
			} else if (typeof values === 'object') {
				for (key in values) {
					if (! values.hasOwnProperty(key) || values[key] === undefined)
						continue;
					if (typeof values[key] === 'object')
						UTILS.form.appendFormData(formData, name + '.' + key, values[key]);
					else
						formData.append(name + '.' + key, values[key]);
				}
			} else {
				formData.append(name, values);
			}
		},
		/**
		 * Helper temporaire  pour les composant multiselect, afin d'éviter d'être prisonnier des div.scrollables
		 * On affiche le dropDown en position fixed
		 * On s'assure que le celui-ci ne déborde pas entre les boites  pour éviter un problème de recouvrement par des boites qui n'ont pas le même contexte z-index.
		 * @this doit être sur le composant select
		 */
		multiselectDropDownHelper: function() {
			var select = $(this);
			var container = select.parent().find('.multiselect-container');
			var ref = select.parent().find('div.btn-group');
			var offset = ref.offset();

			container.css('position', 'fixed');
			container.css('left', offset.left);

			// On prend la largeur du composant.
			container.css('width', ref.width());

			// On positionne la dropdown en bloquant sur le bas de box si on l'atteint ou on la dépasse.
			var top = offset.top + ref.height();
			var containerHeight =  container.height();


			var boxContainer = select.parents(".box");
			if(boxContainer.length) {
				var bottomBox = boxContainer.offset().top + boxContainer.height();
				if((top + Math.min(400,containerHeight)) < bottomBox) {
					container.css('top', top);
				} else {
					container.css('top', Math.max(0, bottomBox - Math.min(400,containerHeight)));
				}
				container.css('zIndex', 65535);
			} else {
				// En dehors d'un box, on vérifie qu'on ne sort pas de l'écran.
				container.css('top', top);
				if(top + 400 > $(document).height()) {
					setTimeout(function() {
						container.css('top', top - container.height());
					}, 0);
				}
				container.css('zIndex', 65535);
			}

			function hideDropDown(event) {
				if (container.find(event.target).length === 0) {
					ref.removeClass('open');
					$(document).off('touchstart click', hideDropDown);
					container.parents().each(function() {
						$(this).off('scroll', hideDropDown);
					});
				}
			}

			$(document).on('touchstart click', hideDropDown);
			container.parents().each(function() {
				$(this).on('scroll', hideDropDown);
			});
		},
		/**
	 	 * Encapsule une action onclick pour éviter les doubles click.
	 	 */
		doubleClickStop: function(action) {
			var lastClickTime;
			return function(event) {
				var clickTime = Date.now();
				if(! lastClickTime || (clickTime - lastClickTime) > 500) {
					lastClickTime = clickTime;
					action(event);
				}
			};
		}
	},
	grid: {
		/**
		* Fonction permettant de marquer les lignes de détail comme étant modifiées après l'execution d'un controle
		* @param row : la ligne à marquer comme modifié si besoin
		* @param rowContext : le context de la ligne
		* @returns : rien
		*/
		updateRowModified: function(rowContext, row) {
			if (rowContext.modifications.includes(row))
				row.gridModified = true;
			return row.gridModified ? row.gridModified : false;
		},
		/** Ajuster les droits "accesses", alimentés par exemple par contrôles LoadDetail, sur les colonnes "columns" */
		applyAccess: function(columns, accesses) {
			if (! accesses)
				return;
			columns.forEach(function(col) {
				if (accesses[col.name]) {
					switch (accesses[col.name]) {
						case 'Invisible':
							col.hidden = true;
							break;
						case 'Required':
							col.required = true;
							col.editable = true;
							break;
						case 'Modifiable':
							col.editable = true;
							break;
						default:
							break;
					}
				}
			});
		}
	},
	deferred: {
		/**
		 *Permet de completer le résultat d'une requête.
		 *@param $defferedSource un deffered, ou un promise, jqXHR ($.post, $.get), bref tout ce qui a une méthode .then(function success(r) {...}, function failed(r) {...})
		 *@param operate function qui transforme le resultat de $defferedSource
		 *@return Deferred de JQuery ($.Deferred)
		 */
		complete: function($deferedSource, operate) {
			var $deferredResult =  $.Deferred();

			$deferedSource.then(function success(result) {
				$deferredResult.resolve(operate(result));
			},
			function failed() {
				$deferredResult.reject('Error');
			});
			return $deferredResult;
		}
	},
	javaFormat: {
		/**
		 * permet de modifier le formatage d'une date du format Java en format moment
		 * map : contient la traduction pour le formatage -> utilisé dans la fonction apply
		 * apply: applique le formatage -> utilisé dans la fonction convert
		 * convert : parcours la chaine à formater (fonction principale)
		 * test: lance une batterie de test sur différent format de date
		 */
		map: {
			d: 'D',
			dd: 'DD',
			D: 'DDD',
			y: 'YYYY',
			yy: 'YY',
			yyy: 'YYYY',
			yyyy: 'YYYY',
			Y: 'gggg',
			YY: 'gg',
			YYYY: 'gggg',
			a: 'A',
			S: 'SSS',
			SS: 'SSS',
			SSS: 'SSS',
			E: 'ddd',
			EE: 'ddd',
			EEE: 'ddd',
			EEEE: 'dddd',
			w: 'W',
			ww: 'WW',
			Z: 'ZZ',
			X: 'ZZ',
			XX: 'ZZ',
			XXX: 'Z',
			u: 'E'
		},
		apply: function(formatString, startIndex, endIndex, openBracket, result) {
			var tempString = formatString.substring(startIndex, endIndex);
			// on vérifie d'abord si tempString est une apostrophe
			if (tempString === '\'') {
					tempString = openBracket ? '[' : ']';
			} else if (!openBracket // on a une apostrophe d'ouvert donc tout ce qu'il y a jusqu'à la prochaine apostrophe ne doit pas être traduit
					&& UTILS.javaFormat.map[tempString]) { // et on vérifie si tempString est dans la map des conversions
					tempString = UTILS.javaFormat.map[tempString];
			}
			return result.concat(tempString);
		},
		convert: function(dateFormat) {
			var beginIndex = -1,
				lastChar = null,
				currentChar = "",
				resultDateFormat = "",
				openBracket = false;  // sert à determiner si on ouvre ou on ferme le crochet

			for (var i = 0; i < dateFormat.length; i++) {
				currentChar = dateFormat.charAt(i);
				if (lastChar === null || lastChar !== currentChar) { // on boucle tant que l'on a le meme caractère
					if (beginIndex !== -1) {
						resultDateFormat = UTILS.javaFormat.apply(dateFormat, beginIndex, i, openBracket, resultDateFormat);
					}
					beginIndex = i;
				}
				if (currentChar === '\'')
					openBracket = !openBracket;
				lastChar = currentChar;
			}
			// et on l'appelle une derniere fois pour avoir le dernier caractère
			return UTILS.javaFormat.apply(dateFormat, beginIndex, dateFormat.length, openBracket, resultDateFormat);
		},
		test: function() {
			var dateFormat = 'dd/MM/yyyy',
				newFormat = UTILS.javaFormat.convert(dateFormat),
				date = moment(),
				result = 'Java date format : {0} -> Moment date format : {1}  RESULTAT: {2}';
			console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = '\'jour\' dd, \'mois\' MM, \'annee\' yyyy';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = 'd/M/yy';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = 'dd/MM/yyyy h:m:s a';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = 'dd/MM/yyyy HH:mm:s';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = 'dd/MM/yyyy HH:mm:s.SSS';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));

			dateFormat = '\'Le "\' EEEE dd MMMM yyyy \'" est le\' u \'er(ème) jour(s) de la semaine\' W'
					+ '\' et le\' D \' jour de \'YYYY';
			newFormat = UTILS.javaFormat.convert(dateFormat);
			console.log(SOLVNET.formatMessage(result, [dateFormat, newFormat, date.format(newFormat)]));
		}
	},
	queue: {
		createAsynchroneRunner: function() {
			var queue = [];

			function executeNext() {
				queue[queue.length-1](end);
			}

			function end() {
				// Retire du sommet de la pile.
				queue.pop();

				// Si il en reste au moins 1 , on passe au suivant. setTimeout permet d'éviter le débordement de pile.
				if(queue.length > 0) {
					executeNext();
				}
			}

			return {
				pushRunnable: function(callback) {
					queue.unshift(callback);
					if (queue.length === 1)
						executeNext();
				}
			};
		}
	},
	formula: {
		checkProperties: function(item, url, property) {
			var defer = $.Deferred();
			$.get(
				SOLVNET.getURL(url, {formula: item.properties[property], toDisplayFormat: false})
			).fail(function(error) {
				defer.reject({ properties: [property] });
			}).done(function(convertFormulaResult) {
				item.properties[property] = convertFormulaResult;
				defer.resolve();
			});
			return defer;
		}
	},
	template: {
		/**
		 * @param objectId - Identifiant de l'objet (marché ou vue)
		 * @param propertyTemplates - string du paramétrage du LayoutItemTypes qui contient la liste des templates sélectionnés au paramétrage.
		 * @param templatesMenuEntries - Entrées de menu de template [ {name: 'exporttemplates', text: t, param: t}]
		 * @return Liste des templates sélectionnés.
		 */
		filterTemplate: function(objectId, propertyTemplates, templatesMenuEntries) {
			if (propertyTemplates === undefined || propertyTemplates.length === 0)
				return templatesMenuEntries;

			var selectedTemplates = propertyTemplates.split(",");
			return templatesMenuEntries.filter(function(template) { return selectedTemplates.indexOf(objectId + '/' + template.text) >= 0; });
		},
		/**
		 * @param objectId - Identifiant de l'objet (marché ou vue)
		 * @param templateFiles - tableau de fichier de template.
		 * @param propertyTemplates - string liste de templates sélectionnés dans la configuration ex: item.properties.templates
		 * @param $itemDiv - div du LayoutItemType
		 * @param optionalSuffix string qui permet de catégoriser les entrées (utile uniquement pour l'agenda, frais, activité)
		 */
		initMenuTemplates: function(objectId, templateFiles, propertyTemplates, $itemDiv, optionalSuffix) {
			if (! templateFiles)
				return;

			var entries = [];
			templateFiles.forEach(function(t) {
				entries.push( {name: 'exporttemplates', text: t, param: optionalSuffix ? optionalSuffix + t : t});
			});
			entries = UTILS.template.filterTemplate(objectId, propertyTemplates, entries);
			if (entries.length) {
				entries.sort();
				$itemDiv.trigger('solvnet.exporttemplatesmenulist', [entries]);
			}
		},
		/**
		 * Rafraîchir les exports de templates disponibles
		 * @param object - Clé d'accès à l'objet métier dans $itemDiv.data
		 * @param propertyTemplates - string liste de templates sélectionnés dans la configuration ex: item.properties.templates
		 * @param $itemDiv - div du LayoutItemType, la fonction par du postulat qu'elle trouvera $itemDiv.data('configurationId') & $itemDiv.data(object).templates
		 */
		initMenuTemplatesForConfiguration: function(object, propertyTemplates, $itemDiv, optionalExtraEntries) {
			// Les entrées disponibles
			var entries = [];
			// La sélection du paramétrage (undefined pour toutes disponibles)
			var selectedTemplates = propertyTemplates ? propertyTemplates.split(",") : undefined;
			// La configuration sélectionnée
			var selectedConfigurationId = $itemDiv.data("configurationId");
			$itemDiv.data(object).templates.forEach(function(t) {
				if (t.id === selectedConfigurationId) {
					t.files.forEach(function(f) {
						if (selectedTemplates === undefined || selectedTemplates.length === 0
							|| selectedTemplates.indexOf(t.id + '/' + f) >= 0) {
							entries.push( {name: 'exporttemplates', text: f, param: f });
						}
					});
				}
			});

			if (optionalExtraEntries)
				entries = entries.concat(optionalExtraEntries);

			if (entries.length > 0) {
				entries.sort();
				$itemDiv.trigger('solvnet.exporttemplatesmenulist', [entries]);
			}
			else {
				$itemDiv.trigger('hidecontrol', ['exporttemplates']);
			}
		}
	},
	ganttChart: {
		split: function() {
			return [
				{id: 'day', caption: SOLVNET.getLang('LayoutParamGanttChartSplitDay')},
				{id: 'week', caption: SOLVNET.getLang('LayoutParamGanttChartSplitWeek')},
				{id: 'month', caption: SOLVNET.getLang('LayoutParamGanttChartSplitMonth')}
			];
		},
		shapeTypes: function() {
			return [
				{value: 'bar', title: SOLVNET.getLang('LayoutParamGanttChartTypeBar')},
				{value: 'line', title: SOLVNET.getLang('LayoutParamGanttChartTypeLine')}
			];
		},
		generateShapes: function(item, items) {
			items.forEach(function(i) {
				i.shapes.forEach(function(s) {
					var shapeColorProperty,
						shapeTypeProperty;
					switch (s.id) {
						case 'visit':
							shapeColorProperty = 'visitShapeColor';
							shapeTypeProperty = 'visitShapeType';
							break;
						case 'delivery':
							shapeColorProperty = 'deliveryShapeColor';
							shapeTypeProperty = 'deliveryShapeType';
							break;
						case 'operation':
							shapeColorProperty = 'operationShapeColor';
							shapeTypeProperty = 'operationShapeType';
							break;
						default:
							break;
					}
					if (shapeColorProperty && shapeTypeProperty) {
						s.round = item.properties['round'] === 'true' ? true : false;
						s.color = item.properties[shapeColorProperty];
						s.type = item.properties[shapeTypeProperty];
					}
				});
			});
		}
	},
	typologies: {
		compare: function(rowA, rowB) {
			for(var x=1;x <= 20;x++) {
				var property = 'active' + (x < 10 ? '0' + x : x);
				if(rowA[property] !== rowB[property]) {
					if(! rowA[property] && rowB[property]) {
						return -1;
					}

					return rowA[property].localeCompare(rowB[property]);
				}
			}
			return 0;
		},
		setActivesAtLevel: function(row, level, max) {
			for(var x=1;x <= 20;x++) {
				var property = 'active' + (x < 10 ? '0' + x : x);

				if(x >= level && x <= max) {
					row[property] = 'Active';
				} else {
					row[property] = 'None';
				}
			}
		},
		getHtmlReferences: function(row, levelLabels, maxLevel) {
			var s = "",
				haveError = false,
				haveRupt = false,
				minOptional = null,
				maxOptional = null,
				minActive = null,
				maxActive = null,
				property,
				x;

			// Première passe permet de savoir si on peut afficher forme abrégé ex: "H2+"
			for(x=1;x <= 20;x++) {
				property = 'active' + (x < 10 ? '0' + x : x);
				if(row[property] === 'Active' || row[property] === 'Optional') {
					if(x > maxLevel) {
						haveError++;
						break;
					} else if(row[property] === 'Active') {
						if(minActive === null) {
							minActive = x;
						}
						maxActive = x;
					} else { // Optional
						if(minOptional === null) {
							minOptional = x;
						}
						maxOptional = x;

					}
				} else {
					if(x <= maxLevel && (maxActive != null || maxOptional != null)) {
						haveRupt = true;
						break;
					}
				}
			}

			if(haveError // supérieur maxLevel
				|| haveRupt	// H1, None, H3
				|| ((minActive !== null) && maxOptional > minActive) // Recouvrement des optionels sur les actifs ~H1,H2,~H3 ou Optionels après actif H1, ~H2, ~H3
				) {
				// Forme détaillé.
				for(x=1;x <= 20;x++) {
					property = 'active' + (x < 10 ? '0' + x : x);
					if(row[property] === 'Active' || row[property] === 'Optional') {
						if(s.length > 0) {
							s += ", ";
						}
						if(row[property] === 'Optional') {
							s += "~";
						}

						if(x > maxLevel) {
							s += "<span class='text-danger'>" + x + "</span>";
						} else {
							s += levelLabels[x-1];
						}
					}
				}
			} else {
				// Forme abrégé.
				if(minOptional !== null) {
					s = "~" + levelLabels[minOptional-1] + (minOptional !== maxOptional ? "+":"");
				}

				if(minActive) {
					if(s.length > 0) {
						s += ", ";
					}
					s += levelLabels[minActive-1] + "+";
				}
			}
			return s;
		},
		getCompressedReferences: function(row, levelLabels, max) {
			var results=[];
			for(var x=1;x <= 20;x++) {
				var property = 'active' + (x < 10 ? '0' + x : x);
				if(x > max) {
					if(row[property] === 'Active' || row[property] === 'Optional') {
						if(results.length > 0 && !results[results.length-1].end) {
							results[results.length-1].end = max;
						}

						results.push({start:x, end:x, error:true});
					}
				} else if(row[property] === 'Active' && (results.length === 0 || results[results.length-1].end !== undefined || results[results.length-1].optional)) {
					if(results.length > 0 && results[results.length-1].optional) {
						results[results.length-1].end = x-1;
					}
					results.push({start:x});
				} else if(row[property] === 'Optional' && (results.length === 0 || results[results.length-1].end !== undefined || !results[results.length-1].optional)) {
					if(results.length > 0 && !results[results.length-1].optional) {
						results[results.length-1].end = x-1;
					}
					results.push({start:x, optional:true});
				} else if(row[property] === 'None' && (results.length > 0 && results[results.length-1].end === undefined)) {
					results[results.length-1].end = x-1;
				}
			}

			var s = "";
			results.forEach(function(segment, index) {
				if(s.length > 0) s+= ", ";

				if(segment.optional) s+= "~";

				if(segment.error) {
					s+= segment.start;
				} else {
					s+= levelLabels[segment.start-1];
					if(segment.end === undefined && segment.start < max) {
						s += "+";
					} else if(segment.end !== undefined && segment.end !== segment.start) {
						s += "-" + levelLabels[segment.end-1];
					}
				}
			});
			return s;
		}
	},
	publication: {
		types: function() {
			return [
				{value: 0, title: SOLVNET.getLang('PublicationNone')},
				{value: 10, title: SOLVNET.getLang('PublicationCustom')},
				{value: 20, title: SOLVNET.getLang('PublicationAll')}
			];
		}
	}
};

/* ******************** */
/* CKEditor integration */
/* ******************** */

function initCKEditor() {
	if ('CKEDITOR' in window)
		return $.Deferred().resolve();

	// La variable globale à positionner AVANT le chargement de "ckeditor.js" pour indiquer à
	// CKEDITOR où aller chercher les fichiers de config, de skins, de langues et de plugins.
	window.CKEDITOR_BASEPATH = SOLVNET.getURL('libs/ckeditor/');

	// Chargement à la volée de CKEditor
	return $.ajax({
		dataType: 'script',
		cache: true,
		url: SOLVNET.getURL('libs/ckeditor/ckeditor.js')
	}).then(function() {
		// "defaultLanguage" n'est utilisé que si la langue du navigateur n'est pas reconnue
		// CKEDITOR.config.defaultLanguage = language || 'fr';
		// "language" définit la lanque par défaut indépendament de la langue du navigateur
		CKEDITOR.config.language = SOLVNET.getLang('Locale') || 'fr';

		// Personnalisation de CKEditor, notamment le bouton "Plus..."
		BaseAPI.ckeditorInit(SOLVNET.getLang('CKEditorMoreButtonLabel'));
	});
}

/** Obtenir le noeud d'un arbre en partant d'un id pour un niveau de profondeur données*/
function findTreeNodeAtLevelForAnId(mapOfAllOptionsById, id, level) {
	if (!id)
		return null;
	var treeNode = mapOfAllOptionsById[id];
	do {
		if (! treeNode)
			return null;
		if (treeNode.depth === level) {
			return treeNode;
		} else if (treeNode.depth < level) {
			return null;
		}
	} while (!!(treeNode = mapOfAllOptionsById[treeNode.parentId]));
	return null;
}

/** Fonction permettant de rafraichir toutes les grilles d'un meme type dans la page
 *
 * @param type : le type de grille que l'on veut trouver (ex : linearProductsGrid)
 * @returns : rien
 */
function refreshGrids(type) {
	var itemDivs = $('#page-content').find('>.box>.box-overflow>.box-content>.box-item');
	// Parcourir les grilles pour les rafraichir
	itemDivs.filter(function () { return $(this).data('item').type === type; }).each(function(index, gridSelector) {
		$(gridSelector).children('.bbm-grid').grid().updateRows();
	});
}

/**
 * Fonction permettant de rafraichir une ligne dans toutes les grilles.
 * @param type : le type de grille que l'on veut trouver (ex : linearProductsGrid)
 * @param modelRow : line to refresh
 * @returns : rien
 *
 * TODO : cette méthode ne devrait pas exister car les grilles pourraient travailler en écoutant "solvnet.modelchange".
 */
function refreshRowOfGrids(type, modelRow) {
	var itemDivs = $('#page-content').find('>.box>.box-overflow>.box-content>.box-item');
	// Parcourir les grilles pour les rafraichir
	itemDivs.filter(function () { return $(this).data('item').type === type; }).each(function(index, gridSelector) {
		var $grid = $(gridSelector).children('.bbm-grid').grid();
		$grid.updateModelRow(modelRow);
	});
}
